/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Date` scalar type represents a year, month and day in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  Date: { input: string; output: string; }
  /** The `Date` scalar type represents a year, month and day in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. Format is `yyyy-MM-dd` */
  DateOnly: { input: string; output: string; }
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: { input: string; output: string; }
  /** The `DateTimeOffset` scalar type represents a date, time and offset from UTC. `DateTimeOffset` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTimeOffset: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  Guid: { input: string; output: string; }
  Long: { input: number; output: number; }
};

export type AddressGraph = {
  address1: Maybe<Scalars['String']['output']>;
  address2: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  company: Maybe<Scalars['String']['output']>;
  country: CountryGraph;
  createdOnUtc: Scalars['DateTimeOffset']['output'];
  email: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
  stateProvince: Maybe<StateProvinceGraph>;
  zipPostalCode: Maybe<Scalars['String']['output']>;
};

export type AddressInputGraph = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  stateProvinceId?: InputMaybe<Scalars['ID']['input']>;
  zipPostalCode?: InputMaybe<Scalars['String']['input']>;
};

export type AdminGraph = {
  executingRequests: Array<ExecutingRequestGraph>;
  export: ExportGraph;
  queries: Array<GraphQlQueryGraph>;
  queryLogs: Array<GraphQlLogGraph>;
  queryStats: Array<QuerySpeedDataGraph>;
  resolveSpeedTest: Scalars['String']['output'];
  serverInfo: ServerInfoGraph;
  zboxTask: ZboxTaskGraph;
  zboxTaskDebugLog: Array<ZboxTaskDebugLog>;
  zboxTasks: Array<ZboxTaskGraph>;
};


export type AdminGraphQueryStatsArgs = {
  admins?: InputMaybe<Scalars['Boolean']['input']>;
  guests?: InputMaybe<Scalars['Boolean']['input']>;
  incomplete: InputMaybe<Scalars['Boolean']['input']>;
  loggedOut?: InputMaybe<Scalars['Boolean']['input']>;
  registeredUsers?: InputMaybe<Scalars['Boolean']['input']>;
  sampleHours?: InputMaybe<Scalars['Float']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  skipLastHours?: InputMaybe<Scalars['Float']['input']>;
  sortOrder?: InputMaybe<LogSortEnum>;
  take: InputMaybe<Scalars['Int']['input']>;
};


export type AdminGraphResolveSpeedTestArgs = {
  inspectConstructors: InputMaybe<Array<Scalars['String']['input']>>;
  services: InputMaybe<Array<Scalars['String']['input']>>;
};


export type AdminGraphZboxTaskArgs = {
  id: Scalars['ID']['input'];
};


export type AdminGraphZboxTasksArgs = {
  completed: InputMaybe<Scalars['Boolean']['input']>;
  ids: InputMaybe<Array<Scalars['ID']['input']>>;
  parentId: InputMaybe<Scalars['ID']['input']>;
  started: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AvailabilityStatusEnum {
  BuildToOrder = 'BUILD_TO_ORDER',
  CallForPrice = 'CALL_FOR_PRICE',
  CallToOrder = 'CALL_TO_ORDER',
  CanBackorder = 'CAN_BACKORDER',
  ContactSeller = 'CONTACT_SELLER',
  Discontinued = 'DISCONTINUED',
  DropShip = 'DROP_SHIP',
  InStock = 'IN_STOCK',
  LowStock = 'LOW_STOCK',
  NotAvailable = 'NOT_AVAILABLE',
  Preorder = 'PREORDER'
}

export type BraintreeGraph = {
  clientToken: Scalars['String']['output'];
};

export type BrowserLogInputGraph = {
  browserHeight?: InputMaybe<Scalars['Int']['input']>;
  browserWidth?: InputMaybe<Scalars['Int']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['Float']['input']>;
  timeFromLoad?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type BrowserLoggingGraph = {
  log: Scalars['Boolean']['output'];
};


export type BrowserLoggingGraphLogArgs = {
  log: BrowserLogInputGraph;
};

export type BulkShipmentTrackingNumberInputGraph = {
  shipments: Array<ShipmentTrackingNumberInputGraph>;
};

export type BulkStockQuantityUpdateInputGraph = {
  products: Array<StockQuantityUpdateInputGraph>;
};

export type CartGraph = {
  add: ShoppingCartGraph;
  addCoupon: ShoppingCartGraph;
  changeQuantity: ShoppingCartGraph;
  moveToCart: ShoppingCartGraph;
  placeOrder: Maybe<Scalars['Guid']['output']>;
  placeOrderExternalPayment: Maybe<Scalars['Guid']['output']>;
  remove: ShoppingCartGraph;
  removeCoupon: ShoppingCartGraph;
  saveForLater: ShoppingCartGraph;
  setDestination: ShoppingCartGraph;
  setLineReference: ShoppingCartGraph;
  setSelectedShippingMethod: Array<ShippingOptionGraph>;
};


export type CartGraphAddArgs = {
  productId: Scalars['ID']['input'];
  qty: Scalars['Int']['input'];
  shoppingCartTypeId: InputMaybe<Scalars['ID']['input']>;
};


export type CartGraphAddCouponArgs = {
  couponCode: Scalars['String']['input'];
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
};


export type CartGraphChangeQuantityArgs = {
  qty: Scalars['Int']['input'];
  shoppingCartItemId: Scalars['ID']['input'];
  shoppingCartTypeId: Scalars['ID']['input'];
};


export type CartGraphMoveToCartArgs = {
  shoppingCartItemId: Scalars['ID']['input'];
};


export type CartGraphPlaceOrderArgs = {
  captchaResponse: InputMaybe<Scalars['String']['input']>;
  cart: ShoppingCartInputGraph;
  deviceData: Scalars['String']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
  shippingAddressId: Scalars['ID']['input'];
};


export type CartGraphPlaceOrderExternalPaymentArgs = {
  billingAddress: AddressInputGraph;
  captchaResponse: InputMaybe<Scalars['String']['input']>;
  cart: ShoppingCartInputGraph;
  deviceData: Scalars['String']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  nonce: Scalars['String']['input'];
  paymentType: PaymentTypeEnum;
  shippingAddress: AddressInputGraph;
};


export type CartGraphRemoveArgs = {
  shoppingCartItemId: Scalars['ID']['input'];
  shoppingCartTypeId: Scalars['ID']['input'];
};


export type CartGraphRemoveCouponArgs = {
  couponCode: Scalars['String']['input'];
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
};


export type CartGraphSaveForLaterArgs = {
  shoppingCartItemId: Scalars['ID']['input'];
};


export type CartGraphSetDestinationArgs = {
  countryId: Scalars['ID']['input'];
  postalCode: InputMaybe<Scalars['String']['input']>;
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
  stateProvinceId: InputMaybe<Scalars['ID']['input']>;
};


export type CartGraphSetLineReferenceArgs = {
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
  reference: Scalars['String']['input'];
  shoppingCartItemId: Scalars['ID']['input'];
  shoppingCartTypeId: Scalars['ID']['input'];
};


export type CartGraphSetSelectedShippingMethodArgs = {
  backordered: Scalars['Boolean']['input'];
  countryId: Scalars['ID']['input'];
  postalCode: InputMaybe<Scalars['String']['input']>;
  provinceId: InputMaybe<Scalars['ID']['input']>;
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
  selectedShippingMethodId: InputMaybe<Scalars['ID']['input']>;
  shippingProfileId: Scalars['ID']['input'];
  shoppingCartItemId: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type CategoryGraph = {
  description: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  metaDescription: Maybe<Scalars['String']['output']>;
  metaKeywords: Maybe<Scalars['String']['output']>;
  metaTitle: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfProducts: Scalars['Int']['output'];
  parentCategory: Maybe<CategoryGraph>;
  parentCategoryId: Maybe<Scalars['ID']['output']>;
  picture: Maybe<PictureGraph>;
  seoName: Maybe<Scalars['String']['output']>;
  showOnHomePage: Scalars['Boolean']['output'];
};

export type CountryGraph = {
  allowsBilling: Scalars['Boolean']['output'];
  allowsShipping: Scalars['Boolean']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numericIsoCode: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  stateProvinces: Array<StateProvinceGraph>;
  subjectToVat: Scalars['Boolean']['output'];
  threeLetterIsoCode: Maybe<Scalars['String']['output']>;
  twoLetterIsoCode: Maybe<Scalars['String']['output']>;
};

export type CustomerDiagramsGraph = {
  createdOnUtc: Scalars['DateTime']['output'];
  diagram: Maybe<DiagramGraph>;
  id: Scalars['ID']['output'];
  relationType: RelationType;
};

export type CustomerGraph = {
  email: Maybe<Scalars['String']['output']>;
  feedbackName: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastIpAddress: Maybe<Scalars['String']['output']>;
  lastLoginDateUtc: Maybe<Scalars['DateTime']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
};

export type DestinationGraph = {
  city: Maybe<Scalars['String']['output']>;
  countryId: Scalars['ID']['output'];
  postalCode: Maybe<Scalars['String']['output']>;
  provinceId: Maybe<Scalars['ID']['output']>;
};

export type DiagramGraph = {
  customerDiagramMappings: Array<CustomerDiagramsGraph>;
  diagramLineItems: Array<DiagramLineItemGraph>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  machineSection: MachineSectionGraph;
  svgString: Maybe<Scalars['String']['output']>;
};

export type DiagramLineItemGraph = {
  comment: Maybe<Scalars['String']['output']>;
  diagram: DiagramGraph;
  id: Scalars['ID']['output'];
  partDrawingIdentifier: Maybe<Scalars['String']['output']>;
  partNumber: Scalars['String']['output'];
  partType: Maybe<Scalars['String']['output']>;
  products: Array<ProductExtendedGraph>;
  quantity: Scalars['Int']['output'];
};

export type DiagramMutationGraph = {
  favoriteDiagram: Scalars['Boolean']['output'];
  logDiagram: Scalars['Boolean']['output'];
};


export type DiagramMutationGraphFavoriteDiagramArgs = {
  diagramId: Scalars['ID']['input'];
  favorite: Scalars['Boolean']['input'];
};


export type DiagramMutationGraphLogDiagramArgs = {
  diagramId: Scalars['ID']['input'];
};

export type DiscountGraph = {
  couponCode: Maybe<Scalars['String']['output']>;
  discountType: DiscountType;
  name: Scalars['String']['output'];
};

export type DiscountModelGraph = {
  couponCode: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Decimal']['output'];
  discountType: DiscountType;
  name: Scalars['String']['output'];
};

export enum DiscountType {
  AssignedToCategories = 'ASSIGNED_TO_CATEGORIES',
  AssignedToManufacturers = 'ASSIGNED_TO_MANUFACTURERS',
  AssignedToOrderSubTotal = 'ASSIGNED_TO_ORDER_SUB_TOTAL',
  AssignedToOrderTotal = 'ASSIGNED_TO_ORDER_TOTAL',
  AssignedToShipping = 'ASSIGNED_TO_SHIPPING',
  AssignedToSkus = 'ASSIGNED_TO_SKUS'
}

export type DiscountUsageHistoryGraph = {
  discount: DiscountGraph;
  discountId: Scalars['Int']['output'];
};

export type ExecutingRequestGraph = {
  body: Maybe<Scalars['String']['output']>;
  contentType: Maybe<Scalars['String']['output']>;
  elapsedMs: Scalars['Float']['output'];
  form: Maybe<Array<KeyValuePairStringString>>;
  host: Scalars['String']['output'];
  ipAddress: Scalars['String']['output'];
  method: Scalars['String']['output'];
  path: Scalars['String']['output'];
  queryString: Scalars['String']['output'];
  scheme: Scalars['String']['output'];
  startDate: Scalars['DateTimeOffset']['output'];
  synchronousElapsedMs: Scalars['Float']['output'];
  synchronousEndDate: Maybe<Scalars['DateTimeOffset']['output']>;
};

export type ExportGraph = {
  products: Array<ProductExtendedGraph>;
  productsBySkus: Array<ProductExtendedGraph>;
};


export type ExportGraphProductsBySkusArgs = {
  skus: Array<Scalars['String']['input']>;
};

export type FeedbackInputGraph = {
  orderId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  productReview: ProductReviewInputGraph;
  sellerReview: SellerReviewInputGraph;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type FilterGraph = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  values: Array<FilterValueGraph>;
};

export type FilterValueGraph = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type GarageGraph = {
  engine: Maybe<Scalars['String']['output']>;
  hours: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  machineAttachment: Maybe<MachineAttachmentGraph>;
  machineEngine: Maybe<MachineEngineGraph>;
  machineModel: MachineModelGraph;
  machineStatus: MachineStatuses;
  name: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  orderItems: Array<OrderItemGraph>;
  picture: Maybe<PictureGraph>;
  serialNumber: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  stockNumber: Maybe<Scalars['String']['output']>;
  year: Maybe<Scalars['Int']['output']>;
};

export type GarageInputGraph = {
  engine?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  machineAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  machineEngineId?: InputMaybe<Scalars['ID']['input']>;
  machineModelId?: InputMaybe<Scalars['ID']['input']>;
  machineStatus: MachineStatuses;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  sortOrder: Scalars['Int']['input'];
  stockNumber?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GarageMutationGraph = {
  add: Maybe<GarageGraph>;
  clearPicture: GarageGraph;
  clearSelected: Scalars['Boolean']['output'];
  delete: Scalars['Boolean']['output'];
  edit: GarageGraph;
  fitmentCheck: Scalars['Boolean']['output'];
  setPicture: GarageGraph;
  setSelected: Scalars['Boolean']['output'];
};


export type GarageMutationGraphAddArgs = {
  garageItem: GarageInputGraph;
  setSelected?: Scalars['Boolean']['input'];
};


export type GarageMutationGraphClearPictureArgs = {
  garageId: Scalars['ID']['input'];
};


export type GarageMutationGraphDeleteArgs = {
  garageId: Scalars['ID']['input'];
};


export type GarageMutationGraphEditArgs = {
  garageId: Scalars['ID']['input'];
  garageItem: GarageInputGraph;
  setSelected?: Scalars['Boolean']['input'];
};


export type GarageMutationGraphFitmentCheckArgs = {
  garageId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type GarageMutationGraphSetPictureArgs = {
  base64PictureData: InputMaybe<Scalars['String']['input']>;
  garageId: Scalars['ID']['input'];
  mimeType: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
};


export type GarageMutationGraphSetSelectedArgs = {
  garageId: InputMaybe<Scalars['ID']['input']>;
};

export type GraphQlLogGraph = {
  customer: Maybe<CustomerGraph>;
  customerId: Maybe<Scalars['Int']['output']>;
  endTime: Maybe<Scalars['DateTimeOffset']['output']>;
  iPAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  query: GraphQlQueryGraph;
  queryId: Scalars['Int']['output'];
  startTime: Scalars['DateTimeOffset']['output'];
  totalTime: Maybe<Scalars['Int']['output']>;
};

export type GraphQlQueryGraph = {
  id: Scalars['ID']['output'];
  lastUsed: Scalars['DateTimeOffset']['output'];
  logs: Array<GraphQlLogGraph>;
  qtyUsed: Scalars['Int']['output'];
  query: Scalars['String']['output'];
  queryClean: Scalars['String']['output'];
};

export type IdAndValuesGraph = {
  id: Scalars['ID']['input'];
  values: Array<Scalars['ID']['input']>;
};

export type ImportExportGraph = {
  bulkAttributeUpdate: ZboxTaskGraph;
  deleteProducts: ZboxTaskGraph;
  importPictures: ZboxTaskGraph;
  importProduct: ZboxTaskGraph;
  importProducts: ZboxTaskGraph;
  unpublishProducts: ZboxTaskGraph;
  updateDiagramSeo: ZboxTaskGraph;
  updateProductsWithNewSkus: ZboxTaskGraph;
  updateShippingProfiles: ZboxTaskGraph;
};


export type ImportExportGraphBulkAttributeUpdateArgs = {
  bulkProductAttributes: Array<ImportProductAttributeInputGraph>;
};


export type ImportExportGraphDeleteProductsArgs = {
  skus: Array<InputMaybe<Scalars['String']['input']>>;
};


export type ImportExportGraphImportPicturesArgs = {
  pictures: Array<ProductPictureInputGraph>;
  productId: Scalars['ID']['input'];
};


export type ImportExportGraphImportProductArgs = {
  product: ImportProductInputGraph;
};


export type ImportExportGraphImportProductsArgs = {
  products: Array<ImportProductInputGraph>;
};


export type ImportExportGraphUnpublishProductsArgs = {
  skus: Array<InputMaybe<Scalars['String']['input']>>;
};


export type ImportExportGraphUpdateProductsWithNewSkusArgs = {
  products: Array<ImportProductWithNewSkuInputGraph>;
};


export type ImportExportGraphUpdateShippingProfilesArgs = {
  products: Array<ShippingProfileInputGraph>;
};

export type ImportProductAttributeInputGraph = {
  sku: Scalars['String']['input'];
  specificationAttributes: Array<InputMaybe<SpecificationAttributeInputGraph>>;
};

export type ImportProductInputGraph = {
  addingProduct: Scalars['Boolean']['input'];
  allowCustomerReviews: Scalars['Boolean']['input'];
  categoryId: Scalars['Int']['input'];
  downloadActivationType?: InputMaybe<Scalars['String']['input']>;
  fitments?: InputMaybe<Array<PartFitmentInputGraph>>;
  fullDescription?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Decimal']['input'];
  interchanges?: InputMaybe<Array<PartInterchangeInputGraph>>;
  isShipEnabled: Scalars['Boolean']['input'];
  length: Scalars['Decimal']['input'];
  manageInventoryMethod: Scalars['String']['input'];
  manufacturerPartNumber: Scalars['String']['input'];
  manufacturers: Scalars['String']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderMaximumQuantity: Scalars['Int']['input'];
  pictures?: InputMaybe<Array<ProductPictureInputGraph>>;
  price: Scalars['Decimal']['input'];
  productTemplate: Scalars['String']['input'];
  productType: Scalars['String']['input'];
  published: Scalars['Boolean']['input'];
  seName: Scalars['String']['input'];
  shippingProfileId?: InputMaybe<Scalars['ID']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  specificationAttributes?: InputMaybe<Array<SpecificationAttributeInputGraph>>;
  stockQuantity: Scalars['Int']['input'];
  vendor: Scalars['String']['input'];
  visibleIndividually: Scalars['Boolean']['input'];
  warehouse?: InputMaybe<Scalars['String']['input']>;
  weight: Scalars['Decimal']['input'];
  width: Scalars['Decimal']['input'];
};

export type ImportProductWithNewSkuInputGraph = {
  addingProduct: Scalars['Boolean']['input'];
  allowCustomerReviews: Scalars['Boolean']['input'];
  categoryId: Scalars['Int']['input'];
  downloadActivationType?: InputMaybe<Scalars['String']['input']>;
  fullDescription?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Decimal']['input'];
  interchanges?: InputMaybe<Array<PartInterchangeInputGraph>>;
  isShipEnabled: Scalars['Boolean']['input'];
  length: Scalars['Decimal']['input'];
  manageInventoryMethod: Scalars['String']['input'];
  manufacturerPartNumber: Scalars['String']['input'];
  manufacturers: Scalars['String']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  newSku: Scalars['String']['input'];
  orderMaximumQuantity: Scalars['Int']['input'];
  pictures?: InputMaybe<Array<ProductPictureInputGraph>>;
  price: Scalars['Decimal']['input'];
  productTemplate: Scalars['String']['input'];
  productType: Scalars['String']['input'];
  published: Scalars['Boolean']['input'];
  seName: Scalars['String']['input'];
  shippingProfileId?: InputMaybe<Scalars['ID']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  specificationAttributes?: InputMaybe<Array<SpecificationAttributeInputGraph>>;
  stockQuantity: Scalars['Int']['input'];
  vendor: Scalars['String']['input'];
  visibleIndividually: Scalars['Boolean']['input'];
  warehouse?: InputMaybe<Scalars['String']['input']>;
  weight: Scalars['Decimal']['input'];
  width: Scalars['Decimal']['input'];
};

export type Info = {
  buildDate: Scalars['DateTimeOffset']['output'];
  selfTest: Scalars['String']['output'];
  version: Scalars['String']['output'];
  zipCodeTemplate: Scalars['String']['output'];
};

export type IntegrationsGraph = {
  order: OrderGraph;
};


export type IntegrationsGraphOrderArgs = {
  customOrderNumber: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['ID']['input']>;
};

export type KeyValuePairStringString = {
  key: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type LeaveFeedbackMutationGraph = {
  add: Scalars['String']['output'];
};


export type LeaveFeedbackMutationGraphAddArgs = {
  feedback: FeedbackInputGraph;
};

export enum LogLevel {
  Information = 'INFORMATION',
  Warning = 'WARNING'
}

export enum LogSortEnum {
  Fastest = 'FASTEST',
  LeastUsed = 'LEAST_USED',
  MostUsed = 'MOST_USED',
  Slowest = 'SLOWEST'
}

export type LoginAndSecurityMutationGraph = {
  changeCampaignPreferences: Scalars['String']['output'];
  changeFeedbackName: Scalars['String']['output'];
  changeName: Scalars['String']['output'];
  changeNumber: Scalars['String']['output'];
};


export type LoginAndSecurityMutationGraphChangeCampaignPreferencesArgs = {
  canEmail: InputMaybe<Scalars['Boolean']['input']>;
  canText: InputMaybe<Scalars['Boolean']['input']>;
};


export type LoginAndSecurityMutationGraphChangeFeedbackNameArgs = {
  feedbackName: Scalars['String']['input'];
};


export type LoginAndSecurityMutationGraphChangeNameArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type LoginAndSecurityMutationGraphChangeNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};

export type MachineAttachmentGraph = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MachineEngineGraph = {
  id: Scalars['ID']['output'];
  machineModel: MachineModelGraph;
  name: Scalars['String']['output'];
};

export type MachineManufacturerGraph = {
  id: Scalars['ID']['output'];
  machineModels: Array<MachineModelGraph>;
  name: Scalars['String']['output'];
};


export type MachineManufacturerGraphMachineModelsArgs = {
  diagramsRequired: InputMaybe<Scalars['Boolean']['input']>;
};

export type MachineManufacturerInputGraph = {
  deleted: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  published: Scalars['Boolean']['input'];
};

export type MachineManufacturerMutationGraph = {
  add: MachineManufacturerGraph;
  delete: Scalars['Boolean']['output'];
  edit: MachineManufacturerGraph;
};


export type MachineManufacturerMutationGraphAddArgs = {
  machineManufacturer: MachineManufacturerInputGraph;
};


export type MachineManufacturerMutationGraphDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MachineManufacturerMutationGraphEditArgs = {
  machineManufacturer: MachineManufacturerInputGraph;
};

export type MachineModelGraph = {
  baseName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  json: Maybe<Scalars['String']['output']>;
  machineEngines: Array<MachineEngineGraph>;
  machineManufacturer: MachineManufacturerGraph;
  machineSections: Array<MachineSectionGraph>;
  machineType: MachineTypeGraph;
  name: Scalars['String']['output'];
  picture: Maybe<PictureGraph>;
  productsForMachine: Array<ProductExtendedGraph>;
};

export type MachineModelInputGraph = {
  baseName?: InputMaybe<Scalars['String']['input']>;
  deleted: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  json?: InputMaybe<Scalars['String']['input']>;
  machineManufacturerId: Scalars['Int']['input'];
  machineTypeId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pictureId?: InputMaybe<Scalars['Int']['input']>;
  published: Scalars['Boolean']['input'];
};

export type MachineModelMutationGraph = {
  add: MachineModelGraph;
  delete: Scalars['Boolean']['output'];
  edit: MachineModelGraph;
};


export type MachineModelMutationGraphAddArgs = {
  machineModel: MachineModelInputGraph;
};


export type MachineModelMutationGraphDeleteArgs = {
  machineModelId: Scalars['ID']['input'];
};


export type MachineModelMutationGraphEditArgs = {
  machineModel: MachineModelInputGraph;
};

export type MachineSectionGraph = {
  description: Maybe<Scalars['String']['output']>;
  diagrams: Array<DiagramGraph>;
  id: Scalars['ID']['output'];
  machineModel: MachineModelGraph;
  machineSection: Maybe<MachineSectionGraph>;
  parentSectionId: Maybe<Scalars['Int']['output']>;
  seoName: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum MachineStatuses {
  Decommissioned = 'DECOMMISSIONED',
  InService = 'IN_SERVICE',
  NeedsRepair = 'NEEDS_REPAIR'
}

export type MachineTypeGraph = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MachineTypeInputGraph = {
  deleted: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  published: Scalars['Boolean']['input'];
};

export type MachineTypeMutationGraph = {
  add: MachineTypeGraph;
  delete: Scalars['Boolean']['output'];
  edit: MachineTypeGraph;
};


export type MachineTypeMutationGraphAddArgs = {
  machineType: MachineTypeInputGraph;
};


export type MachineTypeMutationGraphDeleteArgs = {
  machineTypeId: Scalars['ID']['input'];
};


export type MachineTypeMutationGraphEditArgs = {
  machineType: MachineTypeInputGraph;
};

export type ManufacturerGraph = {
  description: Maybe<Scalars['String']['output']>;
  descriptionHtml: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  metaDescription: Maybe<Scalars['String']['output']>;
  metaKeywords: Maybe<Scalars['String']['output']>;
  metaTitle: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  picture: Maybe<PictureGraph>;
};

export type Mutation = {
  v1: MutationV1;
};

export type MutationAdminGraph = {
  cancelZboxTask: Scalars['String']['output'];
  clearQueryLogs: Scalars['String']['output'];
  /** Ensures that all product pictures are stored as jpgs */
  convertPngToJpg: Scalars['String']['output'];
  resizeAllThumbnails: Scalars['String']['output'];
  restartZboxTask: Scalars['String']['output'];
  setOptions: Scalars['String']['output'];
};


export type MutationAdminGraphCancelZboxTaskArgs = {
  zboxTaskId: Scalars['Int']['input'];
};


export type MutationAdminGraphClearQueryLogsArgs = {
  clearCounters?: Scalars['Boolean']['input'];
};


export type MutationAdminGraphConvertPngToJpgArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  weight: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminGraphResizeAllThumbnailsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  weight: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminGraphRestartZboxTaskArgs = {
  zboxTaskId: Scalars['Int']['input'];
};


export type MutationAdminGraphSetOptionsArgs = {
  logQueries: InputMaybe<Scalars['Boolean']['input']>;
  useCompression: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationIntegrationsGraph = {
  order: MutationIntegrationsOrderGraph;
  product: MutationIntegrationsProductGraph;
};

export type MutationIntegrationsOrderGraph = {
  cancelOrder: Scalars['Boolean']['output'];
  postTrackingNumbers: Scalars['Boolean']['output'];
};


export type MutationIntegrationsOrderGraphCancelOrderArgs = {
  customOrderNumber: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['ID']['input']>;
};


export type MutationIntegrationsOrderGraphPostTrackingNumbersArgs = {
  shipments: BulkShipmentTrackingNumberInputGraph;
};

export type MutationIntegrationsProductGraph = {
  bulkStockQuantityUpdate: Scalars['Boolean']['output'];
};


export type MutationIntegrationsProductGraphBulkStockQuantityUpdateArgs = {
  products: BulkStockQuantityUpdateInputGraph;
};

export type MutationV1 = {
  admin: Maybe<MutationAdminGraph>;
  browserLog: BrowserLoggingGraph;
  cart: Maybe<CartGraph>;
  diagram: Maybe<DiagramMutationGraph>;
  garage: Maybe<GarageMutationGraph>;
  importExport: Maybe<ImportExportGraph>;
  integrations: Maybe<MutationIntegrationsGraph>;
  leaveFeedback: Maybe<LeaveFeedbackMutationGraph>;
  log: Scalars['Boolean']['output'];
  loginAndSecurity: Maybe<LoginAndSecurityMutationGraph>;
  machineManufacturer: Maybe<MachineManufacturerMutationGraph>;
  machineModel: Maybe<MachineModelMutationGraph>;
  machineType: Maybe<MachineTypeMutationGraph>;
  order: Maybe<OrderMutationGraph>;
  paymentMethod: Maybe<PaymentMethodMutationGraph>;
  quote: Maybe<QuoteMutationGraph>;
  shippingAddress: Maybe<ShippingAddressGraph>;
};


export type MutationV1LogArgs = {
  description: InputMaybe<Scalars['String']['input']>;
  logLevel: LogLevel;
  message: Scalars['String']['input'];
};

export type MyGraph = {
  canEmail: Maybe<Scalars['Boolean']['output']>;
  canText: Maybe<Scalars['Boolean']['output']>;
  customerDiagrams: Array<CustomerDiagramsGraph>;
  defaultPaymentMethod: Maybe<PaymentMethodGraph>;
  defaultShippingAddress: Maybe<AddressGraph>;
  email: Maybe<Scalars['String']['output']>;
  feedbackName: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  garage: Array<GarageGraph>;
  garageItem: GarageGraph;
  lastName: Maybe<Scalars['String']['output']>;
  order: Maybe<OrderGraph>;
  orders: OrderConnection;
  paymentMethod: Maybe<PaymentMethodGraph>;
  paymentMethods: Array<PaymentMethodGraph>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  plugins: Maybe<PluginsGraph>;
  quotes: Maybe<Array<QuoteGraph>>;
  review: Maybe<ProductReviewExtendedGraph>;
  savedOrder: Maybe<SavedOrderGraph>;
  savedOrders: Array<SavedOrderGraph>;
  selectedGarageItem: Maybe<GarageGraph>;
  shippingAddress: Maybe<AddressGraph>;
  shippingAddresses: Array<AddressGraph>;
  shoppingCart: ShoppingCartGraph;
  shoppingCartAppliedDiscounts: Array<DiscountModelGraph>;
  shoppingCartShippingMethods: Array<ShippingOptionGraph>;
};


export type MyGraphGarageItemArgs = {
  id: Scalars['ID']['input'];
};


export type MyGraphOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MyGraphOrdersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type MyGraphPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type MyGraphReviewArgs = {
  productId: Scalars['ID']['input'];
};


export type MyGraphSavedOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MyGraphShippingAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MyGraphShoppingCartArgs = {
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
};


export type MyGraphShoppingCartAppliedDiscountsArgs = {
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
};


export type MyGraphShoppingCartShippingMethodsArgs = {
  backordered: Scalars['Boolean']['input'];
  countryId: Scalars['ID']['input'];
  postalCode: InputMaybe<Scalars['String']['input']>;
  provinceId: InputMaybe<Scalars['ID']['input']>;
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
  shippingProfileId: Scalars['ID']['input'];
  shoppingCartItemId: InputMaybe<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

/** A connection from an object to a list of objects of type 'Order'. */
export type OrderConnection = {
  /** A list of all of the edges returned in the connection. */
  edges: Array<OrderEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<OrderGraph>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection from an object to another object of type 'Order'. */
export type OrderEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrderGraph;
};

export type OrderGraph = {
  billingAddress: AddressGraph;
  canCancelOrder: Scalars['Boolean']['output'];
  canRegister: Scalars['Boolean']['output'];
  canRequestReturn: Scalars['Boolean']['output'];
  cardName: Maybe<Scalars['String']['output']>;
  cardType: Maybe<Scalars['String']['output']>;
  checkoutAttributeDescription: Maybe<Scalars['String']['output']>;
  checkoutAttributesXml: Maybe<Scalars['String']['output']>;
  clubOrderGuid: Scalars['ID']['output'];
  createdOnUtc: Scalars['DateTimeOffset']['output'];
  currencyRate: Scalars['Decimal']['output'];
  customOrderNumber: Maybe<Scalars['String']['output']>;
  customValuesXml: Maybe<Scalars['String']['output']>;
  customerId: Scalars['ID']['output'];
  estArrivalDate: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isGuestOrder: Scalars['Boolean']['output'];
  maskedCreditCardNumber: Maybe<Scalars['String']['output']>;
  orderDiscountExclTax: Scalars['Decimal']['output'];
  orderDiscountInclTax: Scalars['Decimal']['output'];
  orderGuid: Scalars['ID']['output'];
  orderItems: Array<OrderItemGraph>;
  orderNotes: Array<OrderNoteGraph>;
  orderShippingExclTax: Scalars['Decimal']['output'];
  orderShippingInclTax: Scalars['Decimal']['output'];
  orderStatus: OrderStatus;
  orderSubtotalDiscountExclTax: Scalars['Decimal']['output'];
  orderSubtotalDiscountInclTax: Scalars['Decimal']['output'];
  orderSubtotalExclTax: Scalars['Decimal']['output'];
  orderSubtotalInclTax: Scalars['Decimal']['output'];
  orderTax: Scalars['Decimal']['output'];
  orderTotal: Scalars['Decimal']['output'];
  paidDateUtc: Maybe<Scalars['DateTimeOffset']['output']>;
  paymentStatus: PaymentStatus;
  pickUpInStore: Scalars['Boolean']['output'];
  pickupAddress: Maybe<AddressGraph>;
  purchaseOrder: Maybe<Scalars['String']['output']>;
  refundedAmount: Scalars['Decimal']['output'];
  shipments: Array<ShipmentGraph>;
  shippingAddress: Maybe<AddressGraph>;
  shippingRateComputationMethodSystemName: Maybe<Scalars['String']['output']>;
  shippingStatus: ShippingStatus;
  taxRates: Maybe<Scalars['String']['output']>;
  usedDiscounts: Array<DiscountUsageHistoryGraph>;
  vatNumber: Maybe<Scalars['String']['output']>;
  zboxShippingMethod: Maybe<Scalars['String']['output']>;
};

export type OrderItemGraph = {
  attributeDescription: Scalars['String']['output'];
  attributesXml: Scalars['String']['output'];
  /** Indicates if the order item was backordered when the order was placed. */
  backorderedWhenOrdered: Scalars['Boolean']['output'];
  discountAmountExclTax: Scalars['Decimal']['output'];
  discountAmountInclTax: Scalars['Decimal']['output'];
  downloadCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDownloadActivated: Scalars['Boolean']['output'];
  itemWeight: Scalars['Decimal']['output'];
  order: OrderGraph;
  orderItemGuid: Scalars['ID']['output'];
  originalProductCost: Scalars['Decimal']['output'];
  priceExclTax: Scalars['Decimal']['output'];
  priceInclTax: Scalars['Decimal']['output'];
  product: ProductExtendedGraph;
  quantity: Scalars['Int']['output'];
  reference: Maybe<Scalars['String']['output']>;
  returnRequestStatus: Maybe<ReturnRequestStatus>;
  unitPriceExclTax: Scalars['Decimal']['output'];
  unitPriceInclTax: Scalars['Decimal']['output'];
};

export type OrderMutationGraph = {
  cancelOrder: Scalars['Boolean']['output'];
  submitReturnRequest: Scalars['Boolean']['output'];
};


export type OrderMutationGraphCancelOrderArgs = {
  id: Scalars['ID']['input'];
};


export type OrderMutationGraphSubmitReturnRequestArgs = {
  orderId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type OrderNoteGraph = {
  createdOnUtc: Scalars['DateTimeOffset']['output'];
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PartFitmentInputGraph = {
  machineModel: PartMachineModelInputGraph;
  sortBy: Scalars['Int']['input'];
};

export type PartInterchangeInputGraph = {
  id: Scalars['Int']['input'];
  interchangePartNumber: Scalars['String']['input'];
  partNumber: Scalars['String']['input'];
};

export type PartMachineModelInputGraph = {
  baseName?: InputMaybe<Scalars['String']['input']>;
  deleted: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  json?: InputMaybe<Scalars['String']['input']>;
  machineManufacturer: MachineManufacturerInputGraph;
  machineType: MachineTypeInputGraph;
  name?: InputMaybe<Scalars['String']['input']>;
  pictureId?: InputMaybe<Scalars['Int']['input']>;
  published: Scalars['Boolean']['input'];
};

export type PaymentMethodGraph = {
  accountNameOrEmail: Maybe<Scalars['String']['output']>;
  address: AddressGraph;
  createdOnUtc: Scalars['DateTimeOffset']['output'];
  creditCardExp: Maybe<Scalars['String']['output']>;
  creditCardLast4: Maybe<Scalars['String']['output']>;
  creditCardType: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  paymentType: PaymentTypeEnum;
  validShippingAddresses: Array<AddressGraph>;
};

export type PaymentMethodMutationGraph = {
  add: PaymentMethodGraph;
  delete: Scalars['Boolean']['output'];
  edit: PaymentMethodGraph;
  setDefault: Scalars['Boolean']['output'];
};


export type PaymentMethodMutationGraphAddArgs = {
  address: AddressInputGraph;
  captchaResponse: InputMaybe<Scalars['String']['input']>;
  deviceData: Scalars['String']['input'];
  nonce: Scalars['String']['input'];
  paymentType: PaymentTypeEnum;
};


export type PaymentMethodMutationGraphDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type PaymentMethodMutationGraphEditArgs = {
  address: InputMaybe<AddressInputGraph>;
  captchaResponse: InputMaybe<Scalars['String']['input']>;
  deviceData: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  nonce: Scalars['String']['input'];
};


export type PaymentMethodMutationGraphSetDefaultArgs = {
  id: Scalars['ID']['input'];
};

export enum PaymentStatus {
  Authorized = 'AUTHORIZED',
  Paid = 'PAID',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Voided = 'VOIDED'
}

export enum PaymentTypeEnum {
  ApplePay = 'APPLE_PAY',
  CreditCard = 'CREDIT_CARD',
  GooglePay = 'GOOGLE_PAY',
  PayPal = 'PAY_PAL'
}

export type PictureGraph = {
  altAttribute: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  seoFilename: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['Int']['output']>;
  thumbnail: Maybe<ThumbnailGraph>;
  thumbnails: Array<ThumbnailGraph>;
  titleAttribute: Maybe<Scalars['String']['output']>;
};


export type PictureGraphThumbnailArgs = {
  size: Scalars['Int']['input'];
};


export type PictureGraphThumbnailsArgs = {
  sizes: Array<Scalars['Int']['input']>;
};

export type PluginsGraph = {
  braintree: Maybe<BraintreeGraph>;
};

export type PriceAndAvailabilityGraph = {
  allowedQuantities: Maybe<Scalars['String']['output']>;
  backorderAvailabilityRange: Maybe<Scalars['String']['output']>;
  canNotify: Scalars['Boolean']['output'];
  oldPrice: Maybe<Scalars['Decimal']['output']>;
  orderMaximumQuantity: Scalars['Int']['output'];
  orderMinimumQuantity: Scalars['Int']['output'];
  preorderAvailabilityStartDateTime: Maybe<Scalars['DateTimeOffset']['output']>;
  price: Maybe<Scalars['Decimal']['output']>;
  status: AvailabilityStatusEnum;
  stock: Maybe<Scalars['Int']['output']>;
};

export type ProductCategoriesGraph = {
  category: CategoryGraph;
  displayOrder: Scalars['Int']['output'];
  isFeaturedProduct: Scalars['Boolean']['output'];
};

/** A connection from an object to a list of objects of type 'ProductExtended'. */
export type ProductExtendedConnection = {
  /** A list of all of the edges returned in the connection. */
  edges: Array<ProductExtendedEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ProductExtendedGraph>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection from an object to another object of type 'ProductExtended'. */
export type ProductExtendedEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ProductExtendedGraph;
};

export type ProductExtendedGraph = {
  /** An additional shipping charge for this product */
  additionalShippingCharge: Scalars['Decimal']['output'];
  /** Allow customer reviews */
  allowCustomerReviews: Scalars['Boolean']['output'];
  /** Sum of # of stars given by reviewers for approved reviews */
  approvedRatingSum: Scalars['Int']['output'];
  /** Total number of approved reviews */
  approvedTotalReviews: Scalars['Int']['output'];
  /** Indicates if the required products should be automatically added to the cart */
  automaticallyAddRequiredProducts: Scalars['Boolean']['output'];
  builtToOrder: Maybe<Scalars['Boolean']['output']>;
  categories: Array<ProductCategoriesGraph>;
  /** Preferred displayed order [on the homepage?] */
  displayOrder: Scalars['Int']['output'];
  fits: Scalars['Boolean']['output'];
  /** The full description in HTML */
  fullDescription: Maybe<Scalars['String']['output']>;
  /** The full description in HTML */
  fullDescriptionHtml: Maybe<Scalars['String']['output']>;
  /** UPC/EAN barcode */
  gtin: Maybe<Scalars['String']['output']>;
  /** Product height in inches */
  height: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  /** Indicates if this product has free shipping */
  isFreeShipping: Scalars['Boolean']['output'];
  /** Indicates if the product is marked as new */
  isNew: Scalars['Boolean']['output'];
  /** Indicates if this product can be shipped */
  isShipEnabled: Scalars['Boolean']['output'];
  /** Indicates if this product is tax exempt */
  isTaxExempt: Scalars['Boolean']['output'];
  /** Product length in inches */
  length: Scalars['Decimal']['output'];
  machineModelFitment: Array<MachineModelGraph>;
  /** Manufacturer part number */
  manufacturerPartNumber: Maybe<Scalars['String']['output']>;
  manufacturers: Array<ProductManufacturersGraph>;
  /** Product description metadat */
  metaDescription: Maybe<Scalars['String']['output']>;
  /** Product keywords metadata */
  metaKeywords: Maybe<Scalars['String']['output']>;
  /** Product title metadata */
  metaTitle: Maybe<Scalars['String']['output']>;
  /** Name of the product */
  name: Maybe<Scalars['String']['output']>;
  /** Indicates the product is not returnable */
  notReturnable: Scalars['Boolean']['output'];
  /** Part interchange */
  partInterchange: Array<Scalars['String']['output']>;
  /** Default product picture */
  picture: Maybe<PictureGraph>;
  pictures: Array<ProductPictureGraph>;
  /** Product pricing and availablity information */
  priceAndAvailability: PriceAndAvailabilityGraph;
  productsAlsoPurchased: Array<Maybe<ProductExtendedGraph>>;
  /** Related products */
  relatedProducts: Array<RelatedProductGraph>;
  /** Indicates if this product requires other products to be purchased with it */
  requireOtherProducts: Scalars['Boolean']['output'];
  /** A comma separated list of ids of products that are required to be ordered with this product */
  requiredProductIds: Maybe<Scalars['String']['output']>;
  /** Product reviews */
  reviews: ProductReviewGraphConnection;
  seoName: Maybe<Scalars['String']['output']>;
  /** Indicates if this product must ship separately from other products */
  shipSeparately: Scalars['Boolean']['output'];
  shippingOptions: Array<ShippingOptionGraph>;
  /** The short product description */
  shortDescription: Maybe<Scalars['String']['output']>;
  /** Show this product on the homepage */
  showOnHomePage: Scalars['Boolean']['output'];
  /** Similar products */
  similarProducts: Array<ProductExtendedGraph>;
  /** Product sku */
  sku: Maybe<Scalars['String']['output']>;
  /** Product specifications */
  specificationAttributes: Array<ProductSpecificationAttributeGraph>;
  /** Product vendors */
  vendor: Maybe<VendorGraph>;
  /** Indicates if this product is visible individually or as part of a group of products */
  visibleIndividually: Scalars['Boolean']['output'];
  /** Product warehouse */
  warehouse: Maybe<WarehouseExtendedGraph>;
  /** Product weight in pounds */
  weight: Scalars['Decimal']['output'];
  /** Product width in inches */
  width: Scalars['Decimal']['output'];
  youtubeEmbedCode: Maybe<Scalars['String']['output']>;
};


export type ProductExtendedGraphFitsArgs = {
  machineModelId: Scalars['ID']['input'];
};


export type ProductExtendedGraphProductsAlsoPurchasedArgs = {
  take: InputMaybe<Scalars['Int']['input']>;
};


export type ProductExtendedGraphReviewsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};


export type ProductExtendedGraphShippingOptionsArgs = {
  countryId: Scalars['ID']['input'];
  postalCode: InputMaybe<Scalars['String']['input']>;
  provinceId: InputMaybe<Scalars['ID']['input']>;
};

export type ProductManufacturersGraph = {
  displayOrder: Scalars['Int']['output'];
  isFeaturedProduct: Scalars['Boolean']['output'];
  manufacturer: ManufacturerGraph;
};

export type ProductPictureGraph = {
  displayOrder: Scalars['Int']['output'];
  picture: PictureGraph;
};

export type ProductPictureInputGraph = {
  displayOrder: Scalars['Int']['input'];
  pictureUrl: Scalars['String']['input'];
};

export type ProductReviewExtendedGraph = {
  arrivedOnTime: Maybe<Scalars['Boolean']['output']>;
  asDescribed: Maybe<Scalars['Boolean']['output']>;
  createdOnUtc: Scalars['DateTimeOffset']['output'];
  helpfulNoTotal: Scalars['Int']['output'];
  helpfulYesTotal: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  orderId: Maybe<Scalars['Int']['output']>;
  promptService: Maybe<Scalars['Boolean']['output']>;
  rating: Scalars['Int']['output'];
  replyText: Maybe<Scalars['String']['output']>;
  reviewText: Scalars['String']['output'];
  suggestion: Scalars['String']['output'];
  title: Scalars['String']['output'];
  wellPackaged: Maybe<Scalars['Boolean']['output']>;
};

export type ProductReviewGraph = {
  createdOnUtc: Scalars['DateTimeOffset']['output'];
  helpfulNoTotal: Scalars['Int']['output'];
  helpfulYesTotal: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
  replyText: Maybe<Scalars['String']['output']>;
  reviewText: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** A connection from an object to a list of objects of type `ProductReviewGraph`. */
export type ProductReviewGraphConnection = {
  /** A list of all of the edges returned in the connection. */
  edges: Array<ProductReviewGraphEdge>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<ProductReviewGraph>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ProductReviewGraph`. */
export type ProductReviewGraphEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ProductReviewGraph;
};

export type ProductReviewInputGraph = {
  review: Scalars['String']['input'];
  starRating: Scalars['Int']['input'];
  suggestion?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ProductSpecificationAttributeGraph = {
  allowFiltering: Scalars['Boolean']['output'];
  customValue: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  showOnProductPage: Scalars['Boolean']['output'];
  specificationAttributeOption: SpecificationAttributeOptionGraph;
};

export type Query = {
  isAuthenticated: Maybe<Scalars['String']['output']>;
  v1: QueryV1;
};

export type QuerySpeedDataGraph = {
  averageTime: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  maxTime: Maybe<Scalars['Int']['output']>;
  minTime: Maybe<Scalars['Int']['output']>;
  query: GraphQlQueryGraph;
  queryId: Scalars['Int']['output'];
};

export type QueryV1 = {
  admin: Maybe<AdminGraph>;
  categories: Array<CategoryGraph>;
  category: CategoryGraph;
  countries: Array<CountryGraph>;
  country: CountryGraph;
  diagram: DiagramGraph;
  diagrams: Array<DiagramGraph>;
  info: Info;
  integrations: Maybe<IntegrationsGraph>;
  machineAttachments: Array<MachineAttachmentGraph>;
  machineManufacturer: MachineManufacturerGraph;
  machineManufacturers: Array<MachineManufacturerGraph>;
  machineModel: MachineModelGraph;
  machineModels: Array<MachineModelGraph>;
  machineSections: Array<MachineSectionGraph>;
  machineType: MachineTypeGraph;
  machineTypes: Array<MachineTypeGraph>;
  my: Maybe<MyGraph>;
  order: Array<OrderGraph>;
  picture: PictureGraph;
  product: ProductExtendedGraph;
  searchResults: SearchResultsGraph;
};


export type QueryV1CategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryV1CountryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryV1DiagramArgs = {
  id: Scalars['ID']['input'];
};


export type QueryV1DiagramsArgs = {
  id: InputMaybe<Scalars['ID']['input']>;
  productId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryV1MachineManufacturerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryV1MachineManufacturersArgs = {
  diagramsRequired: InputMaybe<Scalars['Boolean']['input']>;
  id: InputMaybe<Scalars['ID']['input']>;
  machineTypeId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryV1MachineModelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryV1MachineModelsArgs = {
  diagramsRequired: InputMaybe<Scalars['Boolean']['input']>;
  machineManufacturerId: InputMaybe<Scalars['ID']['input']>;
  machineTypeId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryV1MachineSectionsArgs = {
  machineModelId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryV1MachineTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryV1OrderArgs = {
  clubOrderGuid: Scalars['Guid']['input'];
};


export type QueryV1PictureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryV1ProductArgs = {
  id: InputMaybe<Scalars['ID']['input']>;
  sku: InputMaybe<Scalars['String']['input']>;
};


export type QueryV1SearchResultsArgs = {
  filters: InputMaybe<Array<IdAndValuesGraph>>;
  maxFilterValues?: InputMaybe<Scalars['Int']['input']>;
  relatedManufacturerPartNumber: InputMaybe<Scalars['String']['input']>;
  searchString: InputMaybe<Scalars['String']['input']>;
};

export type QuoteGraph = {
  canOrder: Scalars['Boolean']['output'];
  createdOnUtc: Scalars['DateTimeOffset']['output'];
  expirationDate: Scalars['DateOnly']['output'];
  guid: Scalars['ID']['output'];
  id: Scalars['Int']['output'];
  items: Maybe<Array<Maybe<ShoppingCartItemGraph>>>;
  title: Maybe<Scalars['String']['output']>;
};

export type QuoteInputGraph = {
  canOrder: Scalars['Boolean']['input'];
  customerEmail: Scalars['String']['input'];
  expirationDate: Scalars['DateOnly']['input'];
  id: Scalars['ID']['input'];
  items?: InputMaybe<Array<QuoteItemInputGraph>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteItemInputGraph = {
  id: Scalars['ID']['input'];
  price: Scalars['Decimal']['input'];
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  shippingPrice: Scalars['Decimal']['input'];
};

export type QuoteMutationGraph = {
  add: QuoteGraph;
  delete: Scalars['Boolean']['output'];
  edit: QuoteGraph;
};


export type QuoteMutationGraphAddArgs = {
  quote: QuoteInputGraph;
};


export type QuoteMutationGraphDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type QuoteMutationGraphEditArgs = {
  quote: QuoteInputGraph;
};

export type RelatedProductGraph = {
  displayOrder: Scalars['Int']['output'];
  product: ProductExtendedGraph;
};

export enum RelationType {
  Favorited = 'FAVORITED',
  Recent = 'RECENT',
  Unfavorited = 'UNFAVORITED'
}

export enum ReturnRequestStatus {
  Cancelled = 'CANCELLED',
  ItemsRefunded = 'ITEMS_REFUNDED',
  ItemsRepaired = 'ITEMS_REPAIRED',
  Pending = 'PENDING',
  Received = 'RECEIVED',
  RequestRejected = 'REQUEST_REJECTED',
  ReturnAuthorized = 'RETURN_AUTHORIZED'
}

export type SavedOrderGraph = {
  id: Scalars['ID']['output'];
  items: Array<ShoppingCartItemGraph>;
};

export type SearchResultsGraph = {
  emptyFilters: Array<FilterGraph>;
  filters: Array<FilterGraph>;
  productsConnection: ProductExtendedConnection;
};


export type SearchResultsGraphProductsConnectionArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sortMethod: InputMaybe<SortMethodEnum>;
};

export type SellerReviewInputGraph = {
  arrivedOnTime?: InputMaybe<Scalars['Boolean']['input']>;
  asDescribed?: InputMaybe<Scalars['Boolean']['input']>;
  promptService?: InputMaybe<Scalars['Boolean']['input']>;
  wellPackaged?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServerInfoGraph = {
  clearedCollectedMemoryUsage: Scalars['Long']['output'];
  collectedMemoryUsage: Scalars['Long']['output'];
  is64BitOperatingSystem: Scalars['Boolean']['output'];
  is64BitProcess: Scalars['Boolean']['output'];
  logQueries: Scalars['Boolean']['output'];
  logicalProcessors: Scalars['Int']['output'];
  memoryUsage: Scalars['Long']['output'];
  peakVirtualMemorySize: Scalars['Long']['output'];
  peakWorkingSet: Scalars['Long']['output'];
  platform: Scalars['String']['output'];
  privateMemorySize: Scalars['Long']['output'];
  systemPageSize: Scalars['Int']['output'];
  useCompression: Scalars['Boolean']['output'];
  virtualMemorySize: Scalars['Long']['output'];
  workingSet: Scalars['Long']['output'];
};

export type ShipmentGraph = {
  adminComment: Maybe<Scalars['String']['output']>;
  createdOnUtc: Scalars['DateTimeOffset']['output'];
  deliveryDateLocal: Maybe<Scalars['DateTime']['output']>;
  deliveryDateUtc: Maybe<Scalars['DateTimeOffset']['output']>;
  id: Scalars['ID']['output'];
  isShipped: Maybe<Scalars['Boolean']['output']>;
  shipmentItems: Array<ShipmentItemGraph>;
  shippedDateUtc: Maybe<Scalars['DateTimeOffset']['output']>;
  totalWeight: Scalars['Decimal']['output'];
  trackingNumber: Maybe<Scalars['String']['output']>;
  trackingNumberUrl: Maybe<Scalars['String']['output']>;
};

export type ShipmentItemGraph = {
  id: Scalars['ID']['output'];
  orderItem: Maybe<OrderItemGraph>;
  quantity: Scalars['Int']['output'];
};

export type ShipmentTrackingNumberInputGraph = {
  customOrderNumber: Scalars['String']['input'];
  shipDate: Scalars['Date']['input'];
  shipmentItems: Array<ShipmentTrackingNumberItemInputGraph>;
  totalWeight?: InputMaybe<Scalars['Decimal']['input']>;
  trackingNumber: Scalars['String']['input'];
};

export type ShipmentTrackingNumberItemInputGraph = {
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type ShippingAddressGraph = {
  add: AddressGraph;
  delete: Scalars['Boolean']['output'];
  edit: AddressGraph;
  setDefault: Scalars['Boolean']['output'];
};


export type ShippingAddressGraphAddArgs = {
  address: AddressInputGraph;
};


export type ShippingAddressGraphDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type ShippingAddressGraphEditArgs = {
  address: AddressInputGraph;
  id: Scalars['ID']['input'];
};


export type ShippingAddressGraphSetDefaultArgs = {
  id: Scalars['ID']['input'];
};

export type ShippingOptionGraph = {
  eta: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
  selected: Scalars['Boolean']['output'];
};

export type ShippingProfileInputGraph = {
  newPrice?: InputMaybe<Scalars['Decimal']['input']>;
  shippingProfileId: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export enum ShippingStatus {
  Delivered = 'DELIVERED',
  NotYetShipped = 'NOT_YET_SHIPPED',
  PartiallyShipped = 'PARTIALLY_SHIPPED',
  Shipped = 'SHIPPED',
  ShippingNotRequired = 'SHIPPING_NOT_REQUIRED'
}

export type ShoppingCartGraph = {
  appliedDiscounts: Array<DiscountModelGraph>;
  destination: DestinationGraph;
  errors: Array<Scalars['String']['output']>;
  estimatedItemTaxRate: Maybe<Scalars['Decimal']['output']>;
  estimatedShippingTaxRate: Maybe<Scalars['Decimal']['output']>;
  itemCount: Scalars['Int']['output'];
  poNumber: Maybe<Scalars['String']['output']>;
  productGroups: Array<ShoppingCartGroupGraph>;
  savedForLaterItems: Array<ShoppingCartItemGraph>;
  warnings: Array<Scalars['String']['output']>;
};

export type ShoppingCartGroupGraph = {
  backordered: Scalars['Boolean']['output'];
  items: Array<ShoppingCartItemGraph>;
  shippingMethods: Array<ShippingOptionGraph>;
  shippingProfileId: Scalars['ID']['output'];
  shoppingCartItemId: Maybe<Scalars['ID']['output']>;
  vendorId: Scalars['ID']['output'];
  warehouseId: Scalars['ID']['output'];
};


export type ShoppingCartGroupGraphShippingMethodsArgs = {
  countryId: Scalars['ID']['input'];
  postalCode: InputMaybe<Scalars['String']['input']>;
  provinceId: InputMaybe<Scalars['ID']['input']>;
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
};

export type ShoppingCartGroupInputGraph = {
  backordered: Scalars['Boolean']['input'];
  items: Array<InputMaybe<ShoppingCartItemInputGraph>>;
  shippingMethodId: Scalars['ID']['input'];
  shippingPrice: Scalars['Decimal']['input'];
  shoppingCartItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type ShoppingCartInputGraph = {
  discountAmount: Scalars['Decimal']['input'];
  groups: Array<InputMaybe<ShoppingCartGroupInputGraph>>;
  poNumber: Scalars['String']['input'];
  quoteGuid?: InputMaybe<Scalars['Guid']['input']>;
};

export type ShoppingCartItemGraph = {
  backordered: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  price: Maybe<Scalars['Decimal']['output']>;
  product: ProductExtendedGraph;
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  quoteId: Maybe<Scalars['ID']['output']>;
  reference: Maybe<Scalars['String']['output']>;
};

export type ShoppingCartItemInputGraph = {
  price: Scalars['Decimal']['input'];
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export enum SortMethodEnum {
  AToZ = 'A_TO_Z',
  BestSelling = 'BEST_SELLING',
  Default = 'DEFAULT',
  HighestRating = 'HIGHEST_RATING',
  PriceHigh = 'PRICE_HIGH',
  PriceLow = 'PRICE_LOW',
  Relevance = 'RELEVANCE',
  ZToA = 'Z_TO_A'
}

export type SpecificationAttributeGraph = {
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  specificationAttributeOptions: Array<SpecificationAttributeOptionGraph>;
};

export type SpecificationAttributeInputGraph = {
  allowFiltering: Scalars['Boolean']['input'];
  displayOrder: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  showOnProductPage: Scalars['Boolean']['input'];
  specificationAttributeOptions?: InputMaybe<Array<SpecificationAttributeOptionInputGraph>>;
};

export type SpecificationAttributeOptionGraph = {
  colorSquaresRgb: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  specificationAttribute: SpecificationAttributeGraph;
};

export type SpecificationAttributeOptionInputGraph = {
  colorSquaresRgb?: InputMaybe<Scalars['String']['input']>;
  displayOrder: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type StateProvinceGraph = {
  abbreviation: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
};

export type StockQuantityUpdateInputGraph = {
  hiveWarehouseId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type ThumbnailGraph = {
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type VendorGraph = {
  address: Maybe<AddressGraph>;
  description: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metaDescription: Maybe<Scalars['String']['output']>;
  metaKeywords: Maybe<Scalars['String']['output']>;
  metaTitle: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  picture: Maybe<PictureGraph>;
};

export type WarehouseExtendedGraph = {
  address: Maybe<AddressGraph>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ZboxTaskDebugLog = {
  dateTimeUtc: Scalars['DateTime']['output'];
  message: Maybe<Scalars['String']['output']>;
};

export type ZboxTaskGraph = {
  children: Array<ZboxTaskGraph>;
  completed: Maybe<Scalars['Boolean']['output']>;
  data: Maybe<Scalars['String']['output']>;
  dateAddedUtc: Scalars['DateTimeOffset']['output'];
  dateCompletedUtc: Maybe<Scalars['DateTimeOffset']['output']>;
  dateStartedUtc: Maybe<Scalars['DateTimeOffset']['output']>;
  id: Scalars['ID']['output'];
  log: Maybe<ZboxTaskLogGraph>;
  logId: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  parent: Maybe<ZboxTaskGraph>;
  parentId: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  started: Scalars['Boolean']['output'];
  success: Maybe<Scalars['Boolean']['output']>;
  weight: Scalars['Int']['output'];
  zboxTaskLogs: Array<ZboxTaskLogGraph>;
};

export type ZboxTaskLogGraph = {
  id: Scalars['ID']['output'];
  indent: Scalars['Int']['output'];
  loggedAtUtc: Scalars['DateTimeOffset']['output'];
  message: Scalars['String']['output'];
  zboxTask: ZboxTaskGraph;
  zboxTaskId: Scalars['Int']['output'];
};

export type RecentlyViewedSearchResultsQueryVariables = Exact<{
  filters: InputMaybe<Array<IdAndValuesGraph> | IdAndValuesGraph>;
}>;


export type RecentlyViewedSearchResultsQuery = { v1: { searchResults: { productsConnection: { items: Array<{ id: string, name: string | null, seoName: string | null, picture: { imageUrl: string } | null }> } } } };

export type AddAddressMutationVariables = Exact<{
  address: AddressInputGraph;
}>;


export type AddAddressMutation = { v1: { shippingAddress: { add: { id: string, firstName: string, lastName: string, company: string | null, email: string | null, address1: string | null, address2: string | null, city: string | null, zipPostalCode: string | null, phoneNumber: string | null, createdOnUtc: string, country: { id: string, name: string }, stateProvince: { id: string, name: string, abbreviation: string | null } | null } } | null } };

export type AddCouponMutationVariables = Exact<{
  couponCode: Scalars['String']['input'];
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
}>;


export type AddCouponMutation = { v1: { cart: { addCoupon: { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> } } | null } };

export type AddFeedbackMutationVariables = Exact<{
  feedback: FeedbackInputGraph;
}>;


export type AddFeedbackMutation = { v1: { leaveFeedback: { add: string } | null } };

export type AddPaymentMutationVariables = Exact<{
  address: AddressInputGraph;
  paymentType: PaymentTypeEnum;
  nonce: Scalars['String']['input'];
  deviceData: Scalars['String']['input'];
  captchaResponse: InputMaybe<Scalars['String']['input']>;
}>;


export type AddPaymentMutation = { v1: { paymentMethod: { add: { id: string, accountNameOrEmail: string | null, paymentType: PaymentTypeEnum, creditCardType: string | null, creditCardLast4: string | null, creditCardExp: string | null, displayOrder: number, createdOnUtc: string, address: { id: string, firstName: string, lastName: string, company: string | null, email: string | null, address1: string | null, address2: string | null, city: string | null, zipPostalCode: string | null, phoneNumber: string | null, createdOnUtc: string, country: { id: string, name: string }, stateProvince: { id: string, name: string, abbreviation: string | null } | null }, validShippingAddresses: Array<{ id: string }> } } | null } };

export type AddProductToCartFromCatalogMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  shoppingCartTypeId: Scalars['ID']['input'];
  qty: Scalars['Int']['input'];
}>;


export type AddProductToCartFromCatalogMutation = { v1: { cart: { add: { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> } } | null } };

export type AddQuoteMutationVariables = Exact<{
  quote: QuoteInputGraph;
}>;


export type AddQuoteMutation = { v1: { quote: { add: { id: number, guid: string, title: string | null, createdOnUtc: string, expirationDate: string, canOrder: boolean, items: Array<{ id: string, productId: string, quantity: number, price: number | null, reference: string | null, backordered: boolean } | null> | null } } | null } };

export type CancelOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelOrderMutation = { v1: { order: { cancelOrder: boolean } | null } };

export type CartSetDestinationExternalPaymentMutationVariables = Exact<{
  countryId: Scalars['ID']['input'];
  stateProvinceId: InputMaybe<Scalars['ID']['input']>;
  postalCode: InputMaybe<Scalars['String']['input']>;
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
}>;


export type CartSetDestinationExternalPaymentMutation = { v1: { cart: { setDestination: { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }>, shippingMethods: Array<{ eta: string | null, id: string, name: string, price: number, selected: boolean }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> } } | null } };

export type CartSetDestinationMutationVariables = Exact<{
  countryId: Scalars['ID']['input'];
  stateProvinceId: InputMaybe<Scalars['ID']['input']>;
  postalCode: InputMaybe<Scalars['String']['input']>;
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
}>;


export type CartSetDestinationMutation = { v1: { cart: { setDestination: { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> } } | null } };

export type CartSetLineReferenceMutationVariables = Exact<{
  shoppingCartItemId: Scalars['ID']['input'];
  reference: Scalars['String']['input'];
  shoppingCartTypeId: Scalars['ID']['input'];
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
}>;


export type CartSetLineReferenceMutation = { v1: { cart: { setLineReference: { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> } } | null } };

export type ChangeFeedbackNameMutationVariables = Exact<{
  feedbackName: Scalars['String']['input'];
}>;


export type ChangeFeedbackNameMutation = { v1: { loginAndSecurity: { changeFeedbackName: string } | null } };

export type ChangeNameMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}>;


export type ChangeNameMutation = { v1: { loginAndSecurity: { changeName: string } | null } };

export type ChangeNumberMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type ChangeNumberMutation = { v1: { loginAndSecurity: { changeNumber: string } | null } };

export type ChangeQuantityInCartMutationVariables = Exact<{
  shoppingCartItemId: Scalars['ID']['input'];
  shoppingCartTypeId: Scalars['ID']['input'];
  qty: Scalars['Int']['input'];
}>;


export type ChangeQuantityInCartMutation = { v1: { cart: { changeQuantity: { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> } } | null } };

export type CheckoutExternalPaymentMutationVariables = Exact<{
  email: InputMaybe<Scalars['String']['input']>;
  nonce: Scalars['String']['input'];
  shippingAddress: AddressInputGraph;
  billingAddress: AddressInputGraph;
  cart: ShoppingCartInputGraph;
  deviceData: Scalars['String']['input'];
  paymentType: PaymentTypeEnum;
  captchaResponse: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckoutExternalPaymentMutation = { v1: { cart: { placeOrderExternalPayment: string | null } | null } };

export type CheckoutMutationVariables = Exact<{
  shippingAddressId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
  cart: ShoppingCartInputGraph;
  email: InputMaybe<Scalars['String']['input']>;
  deviceData: Scalars['String']['input'];
  captchaResponse: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckoutMutation = { v1: { cart: { placeOrder: string | null } | null } };

export type DeleteAddressMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
}>;


export type DeleteAddressMutation = { v1: { shippingAddress: { delete: boolean } | null } };

export type DeletePaymentMutationVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type DeletePaymentMutation = { v1: { paymentMethod: { delete: boolean } | null } };

export type EditAddressMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
  address: AddressInputGraph;
}>;


export type EditAddressMutation = { v1: { shippingAddress: { edit: { id: string, firstName: string, lastName: string, company: string | null, email: string | null, address1: string | null, address2: string | null, city: string | null, zipPostalCode: string | null, phoneNumber: string | null, createdOnUtc: string, country: { id: string, name: string }, stateProvince: { id: string, name: string, abbreviation: string | null } | null } } | null } };

export type EditPaymentMutationVariables = Exact<{
  paymentId: Scalars['ID']['input'];
  address: InputMaybe<AddressInputGraph>;
  nonce: Scalars['String']['input'];
  deviceData: Scalars['String']['input'];
  captchaResponse: InputMaybe<Scalars['String']['input']>;
}>;


export type EditPaymentMutation = { v1: { paymentMethod: { edit: { id: string, accountNameOrEmail: string | null, paymentType: PaymentTypeEnum, creditCardType: string | null, creditCardLast4: string | null, creditCardExp: string | null, displayOrder: number, createdOnUtc: string, address: { id: string, firstName: string, lastName: string, company: string | null, email: string | null, address1: string | null, address2: string | null, city: string | null, zipPostalCode: string | null, phoneNumber: string | null, createdOnUtc: string, country: { id: string, name: string }, stateProvince: { id: string, name: string, abbreviation: string | null } | null }, validShippingAddresses: Array<{ id: string }> } } | null } };

export type AddMachineMutationVariables = Exact<{
  garageItem: GarageInputGraph;
  setSelected: Scalars['Boolean']['input'];
}>;


export type AddMachineMutation = { v1: { garage: { add: { id: string, hours: number | null, machineStatus: MachineStatuses, name: string | null, notes: string | null, serialNumber: string | null, sortOrder: number, stockNumber: string | null, year: number | null, machineAttachment: { id: string, name: string } | null, machineEngine: { id: string, name: string } | null, machineModel: { baseName: string | null, name: string, id: string, machineEngines: Array<{ id: string, name: string }>, machineManufacturer: { id: string, name: string }, machineType: { id: string, name: string }, picture: { id: string, imageUrl: string, thumbnail: { url: string } | null } | null } } | null } | null } };

export type CheckFitmentMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  garageId: Scalars['ID']['input'];
}>;


export type CheckFitmentMutation = { v1: { garage: { fitmentCheck: boolean } | null } };

export type ClearMachineMutationVariables = Exact<{
  garageId: Scalars['ID']['input'];
}>;


export type ClearMachineMutation = { v1: { garage: { clearPicture: { id: string, name: string | null, picture: { id: string } | null } } | null } };

export type DeleteMachineMutationVariables = Exact<{
  garageId: Scalars['ID']['input'];
}>;


export type DeleteMachineMutation = { v1: { garage: { delete: boolean } | null } };

export type EditMachineMutationVariables = Exact<{
  garageId: Scalars['ID']['input'];
  garageItem: GarageInputGraph;
}>;


export type EditMachineMutation = { v1: { garage: { edit: { id: string, hours: number | null, machineStatus: MachineStatuses, name: string | null, notes: string | null, serialNumber: string | null, sortOrder: number, stockNumber: string | null, year: number | null, machineAttachment: { id: string } | null, machineEngine: { id: string, name: string } | null, machineModel: { baseName: string | null, name: string, id: string, machineEngines: Array<{ id: string, name: string }>, machineManufacturer: { id: string, name: string }, machineType: { id: string, name: string }, picture: { id: string, imageUrl: string, thumbnail: { url: string } | null } | null } } } | null } };

export type SetMachinePictureMutationVariables = Exact<{
  garageId: Scalars['ID']['input'];
  url: InputMaybe<Scalars['String']['input']>;
  base64PictureData: InputMaybe<Scalars['String']['input']>;
  mimeType: InputMaybe<Scalars['String']['input']>;
}>;


export type SetMachinePictureMutation = { v1: { garage: { setPicture: { id: string, picture: { id: string, imageUrl: string, mimeType: string, seoFilename: string | null, size: number | null, thumbnail: { size: number, url: string } | null } | null } } | null } };

export type SetMachineMutationVariables = Exact<{
  id: InputMaybe<Scalars['ID']['input']>;
}>;


export type SetMachineMutation = { v1: { garage: { setSelected: boolean } | null } };

export type MoveToCartMutationVariables = Exact<{
  shoppingCartItemId: Scalars['ID']['input'];
}>;


export type MoveToCartMutation = { v1: { cart: { moveToCart: { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> } } | null } };

export type RemoveCouponMutationVariables = Exact<{
  couponCode: Scalars['String']['input'];
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
}>;


export type RemoveCouponMutation = { v1: { cart: { removeCoupon: { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> } } | null } };

export type RemoveProductFromCartMutationVariables = Exact<{
  shoppingCartItemId: Scalars['ID']['input'];
  shoppingCartTypeId: Scalars['ID']['input'];
}>;


export type RemoveProductFromCartMutation = { v1: { cart: { remove: { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> } } | null } };

export type SaveForLaterProductMutationVariables = Exact<{
  shoppingCartItemId: Scalars['ID']['input'];
}>;


export type SaveForLaterProductMutation = { v1: { cart: { saveForLater: { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> } } | null } };

export type SetDefaultAddressMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
}>;


export type SetDefaultAddressMutation = { v1: { shippingAddress: { setDefault: boolean } | null } };

export type SetDefaultPaymentMutationVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type SetDefaultPaymentMutation = { v1: { paymentMethod: { setDefault: boolean } | null } };

export type SetSelectedShippingMethodMutationVariables = Exact<{
  countryId: Scalars['ID']['input'];
  provinceId: InputMaybe<Scalars['ID']['input']>;
  postalCode: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
  shippingProfileId: Scalars['ID']['input'];
  backordered: Scalars['Boolean']['input'];
  selectedShippingMethodId: Scalars['ID']['input'];
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
  shoppingCartItemId: InputMaybe<Scalars['ID']['input']>;
}>;


export type SetSelectedShippingMethodMutation = { v1: { cart: { setSelectedShippingMethod: Array<{ eta: string | null, id: string, name: string, price: number, selected: boolean }> } | null } };

export type SubmitReturnRequestMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type SubmitReturnRequestMutation = { v1: { order: { submitReturnRequest: boolean } | null } };

export type MachinePageMachineModelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MachinePageMachineModelQuery = { v1: { machineModel: { id: string, name: string, baseName: string | null, json: string | null, picture: { seoFilename: string | null, mimeType: string, thumbnail: { url: string } | null } | null, machineManufacturer: { id: string, name: string }, machineType: { id: string, name: string }, productsForMachine: Array<{ id: string, name: string | null, seoName: string | null, approvedRatingSum: number, approvedTotalReviews: number, categories: Array<{ category: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMinimumQuantity: number, orderMaximumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null }, picture: { thumbnail: { url: string } | null } | null }>, machineSections: Array<{ diagrams: Array<{ id: string }> }> } } };

export type CatsQueryVariables = Exact<{ [key: string]: never; }>;


export type CatsQuery = { v1: { categories: Array<{ id: string, name: string }> } };

export type InfoQueryVariables = Exact<{ [key: string]: never; }>;


export type InfoQuery = { v1: { info: { version: string } } };

export type UseBookMarkDiagramMutationVariables = Exact<{
  diagramId: Scalars['ID']['input'];
  favorite: Scalars['Boolean']['input'];
}>;


export type UseBookMarkDiagramMutation = { v1: { diagram: { favoriteDiagram: boolean } | null } };

export type BookMarkedDiagramQueryVariables = Exact<{ [key: string]: never; }>;


export type BookMarkedDiagramQuery = { v1: { my: { customerDiagrams: Array<{ relationType: RelationType, diagram: { id: string } | null }> } | null } };

export type DiagramPageMachineSectionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DiagramPageMachineSectionsQuery = { v1: { machineSections: Array<{ id: string, title: string, parentSectionId: number | null, description: string | null, seoName: string | null, diagrams: Array<{ id: string }> }> } };

export type DiagramPageMachineModelQueryVariables = Exact<{
  modelId: Scalars['ID']['input'];
}>;


export type DiagramPageMachineModelQuery = { v1: { machineModel: { id: string, name: string, machineManufacturer: { name: string, id: string } } } };

export type DiagramPageDiagramsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DiagramPageDiagramsQuery = { v1: { diagrams: Array<{ id: string, imageUrl: string | null, diagramLineItems: Array<{ partDrawingIdentifier: string | null, partNumber: string, quantity: number, comment: string | null, products: Array<{ name: string | null, seoName: string | null, id: string, priceAndAvailability: { price: number | null, status: AvailabilityStatusEnum, stock: number | null }, categories: Array<{ displayOrder: number, category: { name: string } }> }> }>, machineSection: { title: string, seoName: string | null, machineModel: { name: string, id: string }, machineSection: { title: string, seoName: string | null, id: string } | null } }> } };

export type LogDiagramMutationVariables = Exact<{
  diagramId: Scalars['ID']['input'];
}>;


export type LogDiagramMutation = { v1: { diagram: { logDiagram: boolean } | null } };

export type AddressBookQueryVariables = Exact<{ [key: string]: never; }>;


export type AddressBookQuery = { v1: { my: { shippingAddresses: Array<{ id: string, firstName: string, lastName: string, company: string | null, email: string | null, address1: string | null, address2: string | null, city: string | null, zipPostalCode: string | null, phoneNumber: string | null, createdOnUtc: string, country: { id: string, name: string }, stateProvince: { id: string, name: string, abbreviation: string | null } | null }> } | null } };

export type AllCustomerReviewsQueryVariables = Exact<{
  productId: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllCustomerReviewsQuery = { v1: { product: { reviews: { items: Array<{ createdOnUtc: string, helpfulNoTotal: number, helpfulYesTotal: number, id: string, rating: number, replyText: string | null, reviewText: string, title: string }> } } } };

export type BraintreeClientTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type BraintreeClientTokenQuery = { v1: { my: { plugins: { braintree: { clientToken: string } | null } | null } | null } };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { v1: { info: { version: string, zipCodeTemplate: string }, categories: Array<{ displayOrder: number, numberOfProducts: number, id: string, name: string, seoName: string | null, parentCategoryId: string | null, showOnHomePage: boolean, picture: { thumbnail: { url: string } | null } | null }> } };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { v1: { countries: Array<{ displayOrder: number, id: string, name: string, twoLetterIsoCode: string | null, stateProvinces: Array<{ abbreviation: string | null, displayOrder: number, id: string, name: string }> }> } };

export type DefaultPaymentAndShippingQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultPaymentAndShippingQuery = { v1: { my: { defaultPaymentMethod: { id: string, accountNameOrEmail: string | null, createdOnUtc: string, creditCardExp: string | null, creditCardLast4: string | null, creditCardType: string | null, displayOrder: number, paymentType: PaymentTypeEnum, address: { address1: string | null, address2: string | null, city: string | null, company: string | null, createdOnUtc: string, email: string | null, firstName: string, id: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string, name: string }, stateProvince: { abbreviation: string | null, id: string, name: string } | null }, validShippingAddresses: Array<{ id: string }> } | null, defaultShippingAddress: { id: string, address1: string | null, address2: string | null, city: string | null, company: string | null, createdOnUtc: string, email: string | null, firstName: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string, name: string }, stateProvince: { abbreviation: string | null, id: string, name: string } | null } | null } | null } };

export type EditMyShippingAddressQueryVariables = Exact<{
  addressId: Scalars['ID']['input'];
}>;


export type EditMyShippingAddressQuery = { v1: { my: { shippingAddress: { id: string, firstName: string, lastName: string, company: string | null, email: string | null, address1: string | null, address2: string | null, city: string | null, zipPostalCode: string | null, phoneNumber: string | null, createdOnUtc: string, country: { id: string, name: string }, stateProvince: { id: string, name: string, abbreviation: string | null } | null } | null } | null } };

export type EmailNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailNotificationsQuery = { isAuthenticated: string | null, v1: { my: { email: string | null } | null } };

export type EmptyFiltersSearchResultsQueryVariables = Exact<{
  searchString: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<Array<IdAndValuesGraph> | IdAndValuesGraph>;
}>;


export type EmptyFiltersSearchResultsQuery = { v1: { searchResults: { emptyFilters: Array<{ id: string, name: string, values: Array<{ id: string, name: string, quantity: number }> }> } } };

export type FeedbackNameQueryVariables = Exact<{ [key: string]: never; }>;


export type FeedbackNameQuery = { v1: { my: { feedbackName: string | null } | null } };

export type FleetMachineQueryVariables = Exact<{ [key: string]: never; }>;


export type FleetMachineQuery = { v1: { machineTypes: Array<{ id: string, name: string }>, machineAttachments: Array<{ id: string, name: string }>, machineManufacturers: Array<{ id: string, name: string }> } };

export type QueryMachineManufacturers2QueryVariables = Exact<{ [key: string]: never; }>;


export type QueryMachineManufacturers2Query = { v1: { machineManufacturers: Array<{ id: string, name: string }> } };

export type QueryMachineManufacturersQueryVariables = Exact<{
  manufacturerId: Scalars['ID']['input'];
}>;


export type QueryMachineManufacturersQuery = { v1: { machineManufacturers: Array<{ name: string, id: string }>, machineModels: Array<{ id: string, name: string, baseName: string | null, productsForMachine: Array<{ id: string }> }> } };

export type FleetQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FleetQueryQuery = { v1: { my: { selectedGarageItem: { id: string } | null, garage: Array<{ id: string, name: string | null, hours: number | null, notes: string | null, machineStatus: MachineStatuses, serialNumber: string | null, sortOrder: number, stockNumber: string | null, year: number | null, engine: string | null, orderItems: Array<{ orderItemGuid: string, id: string, quantity: number, unitPriceExclTax: number, reference: string | null, product: { id: string, name: string | null, seoName: string | null, additionalShippingCharge: number, manufacturerPartNumber: string | null, shipSeparately: boolean, sku: string | null, reviews: { totalCount: number | null }, manufacturers: Array<{ displayOrder: number, manufacturer: { displayOrder: number, id: string, name: string, picture: { imageUrl: string } | null } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null, canNotify: boolean }, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null }, order: { createdOnUtc: string } }>, machineAttachment: { id: string, name: string } | null, machineEngine: { id: string, name: string } | null, machineModel: { id: string, name: string, baseName: string | null, picture: { seoFilename: string | null, mimeType: string, thumbnail: { url: string } | null } | null, machineManufacturer: { id: string, name: string }, machineType: { id: string, name: string } }, picture: { id: string, imageUrl: string, thumbnail: { url: string } | null } | null }> } | null } };

export type LeaveFeedbackQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type LeaveFeedbackQuery = { v1: { my: { order: { createdOnUtc: string, orderStatus: OrderStatus, orderItems: Array<{ id: string, itemWeight: number, orderItemGuid: string, quantity: number, product: { id: string, name: string | null, seoName: string | null, additionalShippingCharge: number, manufacturerPartNumber: string | null, shipSeparately: boolean, sku: string | null, manufacturers: Array<{ displayOrder: number, manufacturer: { displayOrder: number, id: string, name: string, picture: { imageUrl: string } | null } }>, picture: { thumbnail: { url: string } | null } | null, vendor: { id: string, name: string } | null } }> } | null } | null } };

export type LoginAndSecurityQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginAndSecurityQuery = { isAuthenticated: string | null, v1: { my: { firstName: string | null, lastName: string | null, feedbackName: string | null, email: string | null, phoneNumber: string | null } | null } };

export type MachineManufacturersQueryVariables = Exact<{
  machineTypeId: InputMaybe<Scalars['ID']['input']>;
  diagramsRequired: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MachineManufacturersQuery = { v1: { machineManufacturers: Array<{ id: string, name: string }> } };

export type MachineModels2QueryVariables = Exact<{
  manufacturerId: InputMaybe<Scalars['ID']['input']>;
  machineTypeId: InputMaybe<Scalars['ID']['input']>;
}>;


export type MachineModels2Query = { v1: { machineModels: Array<{ id: string, name: string, baseName: string | null, machineEngines: Array<{ id: string, name: string }>, machineManufacturer: { id: string, name: string }, machineType: { id: string, name: string } }> } };

export type NavbarCartTotalQueryVariables = Exact<{
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
}>;


export type NavbarCartTotalQuery = { v1: { my: { shoppingCart: { itemCount: number } } | null } };

export type OrderQueryVariables = Exact<{
  clubOrderGuid: Scalars['Guid']['input'];
}>;


export type OrderQuery = { v1: { order: Array<{ id: string, customerId: string, isGuestOrder: boolean, canRegister: boolean, canRequestReturn: boolean, canCancelOrder: boolean, createdOnUtc: string, customOrderNumber: string | null, clubOrderGuid: string, estArrivalDate: string | null, purchaseOrder: string | null, orderStatus: OrderStatus, orderTotal: number, paymentStatus: PaymentStatus, zboxShippingMethod: string | null, shippingStatus: ShippingStatus, billingAddress: { address1: string | null, address2: string | null, city: string | null, company: string | null, email: string | null, firstName: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string }, stateProvince: { id: string } | null }, orderItems: Array<{ orderItemGuid: string, id: string, quantity: number, unitPriceExclTax: number, reference: string | null, product: { id: string, name: string | null, seoName: string | null, additionalShippingCharge: number, manufacturerPartNumber: string | null, shipSeparately: boolean, sku: string | null, reviews: { totalCount: number | null }, manufacturers: Array<{ displayOrder: number, manufacturer: { displayOrder: number, id: string, name: string, picture: { imageUrl: string } | null } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null, canNotify: boolean }, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null } }>, shipments: Array<{ id: string, deliveryDateUtc: string | null, shippedDateUtc: string | null, totalWeight: number, trackingNumber: string | null, trackingNumberUrl: string | null, shipmentItems: Array<{ id: string, quantity: number, orderItem: { id: string } | null }> }>, shippingAddress: { address1: string | null, address2: string | null, city: string | null, company: string | null, email: string | null, firstName: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string }, stateProvince: { id: string } | null } | null }> } };

export type OrderSummaryQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type OrderSummaryQuery = { v1: { my: { order: { id: string, createdOnUtc: string, customOrderNumber: string | null, orderTotal: number, orderTax: number, orderShippingExclTax: number, orderShippingInclTax: number, orderSubtotalExclTax: number, orderSubtotalInclTax: number, orderSubtotalDiscountExclTax: number, orderSubtotalDiscountInclTax: number, orderDiscountInclTax: number, orderDiscountExclTax: number, billingAddress: { address1: string | null, address2: string | null, city: string | null, company: string | null, email: string | null, firstName: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string }, stateProvince: { id: string } | null }, orderItems: Array<{ id: string, quantity: number, product: { id: string, name: string | null, additionalShippingCharge: number, manufacturerPartNumber: string | null, approvedRatingSum: number, approvedTotalReviews: number, shipSeparately: boolean, sku: string | null, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMinimumQuantity: number, orderMaximumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null }, manufacturers: Array<{ displayOrder: number, manufacturer: { displayOrder: number, id: string, name: string, picture: { imageUrl: string } | null } }>, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null } }>, shipments: Array<{ id: string, deliveryDateUtc: string | null, shippedDateUtc: string | null, totalWeight: number, trackingNumber: string | null, shipmentItems: Array<{ id: string, quantity: number, orderItem: { id: string } | null }> }>, shippingAddress: { address1: string | null, address2: string | null, city: string | null, company: string | null, email: string | null, firstName: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string }, stateProvince: { id: string } | null } | null, usedDiscounts: Array<{ discount: { name: string, couponCode: string | null, discountType: DiscountType } }> } | null } | null } };

export type OrderPartialQueryFragmentFragment = { id: string, customerId: string, isGuestOrder: boolean, canRegister: boolean, canRequestReturn: boolean, canCancelOrder: boolean, createdOnUtc: string, customOrderNumber: string | null, clubOrderGuid: string, estArrivalDate: string | null, purchaseOrder: string | null, orderStatus: OrderStatus, orderTotal: number, paymentStatus: PaymentStatus, zboxShippingMethod: string | null, shippingStatus: ShippingStatus, billingAddress: { address1: string | null, address2: string | null, city: string | null, company: string | null, email: string | null, firstName: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string }, stateProvince: { id: string } | null }, orderItems: Array<{ orderItemGuid: string, id: string, quantity: number, unitPriceExclTax: number, reference: string | null, product: { id: string, name: string | null, seoName: string | null, additionalShippingCharge: number, manufacturerPartNumber: string | null, shipSeparately: boolean, sku: string | null, reviews: { totalCount: number | null }, manufacturers: Array<{ displayOrder: number, manufacturer: { displayOrder: number, id: string, name: string, picture: { imageUrl: string } | null } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null, canNotify: boolean }, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null } }>, shipments: Array<{ id: string, deliveryDateUtc: string | null, shippedDateUtc: string | null, totalWeight: number, trackingNumber: string | null, trackingNumberUrl: string | null, shipmentItems: Array<{ id: string, quantity: number, orderItem: { id: string } | null }> }>, shippingAddress: { address1: string | null, address2: string | null, city: string | null, company: string | null, email: string | null, firstName: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string }, stateProvince: { id: string } | null } | null };

export type OrdersAndReturnsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type OrdersAndReturnsQueryQuery = { v1: { my: { orders: { totalCount: number, pageInfo: { endCursor: string | null, startCursor: string | null }, items: Array<{ id: string, customerId: string, isGuestOrder: boolean, canRegister: boolean, canRequestReturn: boolean, canCancelOrder: boolean, createdOnUtc: string, customOrderNumber: string | null, clubOrderGuid: string, estArrivalDate: string | null, purchaseOrder: string | null, orderStatus: OrderStatus, orderTotal: number, paymentStatus: PaymentStatus, zboxShippingMethod: string | null, shippingStatus: ShippingStatus, billingAddress: { address1: string | null, address2: string | null, city: string | null, company: string | null, email: string | null, firstName: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string }, stateProvince: { id: string } | null }, orderItems: Array<{ orderItemGuid: string, id: string, quantity: number, unitPriceExclTax: number, reference: string | null, product: { id: string, name: string | null, seoName: string | null, additionalShippingCharge: number, manufacturerPartNumber: string | null, shipSeparately: boolean, sku: string | null, reviews: { totalCount: number | null }, manufacturers: Array<{ displayOrder: number, manufacturer: { displayOrder: number, id: string, name: string, picture: { imageUrl: string } | null } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null, canNotify: boolean }, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null } }>, shipments: Array<{ id: string, deliveryDateUtc: string | null, shippedDateUtc: string | null, totalWeight: number, trackingNumber: string | null, trackingNumberUrl: string | null, shipmentItems: Array<{ id: string, quantity: number, orderItem: { id: string } | null }> }>, shippingAddress: { address1: string | null, address2: string | null, city: string | null, company: string | null, email: string | null, firstName: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string }, stateProvince: { id: string } | null } | null }> } } | null } };

export type CustomerDiagramsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerDiagramsQuery = { v1: { my: { customerDiagrams: Array<{ id: string, createdOnUtc: string, relationType: RelationType, diagram: { id: string, machineSection: { title: string, seoName: string | null, machineModel: { id: string, name: string, machineManufacturer: { name: string } } } } | null }> } | null } };

export type MachineManufacturerWithModelDiagramsQueryVariables = Exact<{
  machineManufacturerId: Scalars['ID']['input'];
}>;


export type MachineManufacturerWithModelDiagramsQuery = { v1: { machineManufacturers: Array<{ id: string, name: string, machineModels: Array<{ id: string, name: string }> }> } };

export type PaymentMethodQueryVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type PaymentMethodQuery = { v1: { my: { paymentMethod: { id: string, accountNameOrEmail: string | null, paymentType: PaymentTypeEnum, creditCardType: string | null, creditCardLast4: string | null, creditCardExp: string | null, displayOrder: number, createdOnUtc: string, address: { id: string, firstName: string, lastName: string, company: string | null, email: string | null, address1: string | null, address2: string | null, city: string | null, zipPostalCode: string | null, phoneNumber: string | null, createdOnUtc: string, country: { id: string, name: string }, stateProvince: { id: string, name: string, abbreviation: string | null } | null }, validShippingAddresses: Array<{ id: string }> } | null } | null } };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { v1: { my: { paymentMethods: Array<{ id: string, accountNameOrEmail: string | null, paymentType: PaymentTypeEnum, creditCardType: string | null, creditCardLast4: string | null, creditCardExp: string | null, displayOrder: number, createdOnUtc: string, address: { id: string, firstName: string, lastName: string, company: string | null, email: string | null, address1: string | null, address2: string | null, city: string | null, zipPostalCode: string | null, phoneNumber: string | null, createdOnUtc: string, country: { id: string, name: string }, stateProvince: { id: string, name: string, abbreviation: string | null } | null }, validShippingAddresses: Array<{ id: string }> }> } | null } };

export type PreviouslyOrderedProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type PreviouslyOrderedProductsQuery = { v1: { my: { orders: { items: Array<{ createdOnUtc: string, orderItems: Array<{ id: string, quantity: number, product: { seoName: string | null, id: string, name: string | null, manufacturerPartNumber: string | null, approvedRatingSum: number, approvedTotalReviews: number, shipSeparately: boolean, sku: string | null, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMinimumQuantity: number, orderMaximumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null }, manufacturers: Array<{ displayOrder: number, manufacturer: { displayOrder: number, id: string, name: string, picture: { imageUrl: string } | null } }>, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null } }> }> } } | null } };

export type ProductPageAlsoPurchasedQueryVariables = Exact<{
  productId: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProductPageAlsoPurchasedQuery = { v1: { product: { productsAlsoPurchased: Array<{ id: string } | null> } } };

export type ProductPageQueryVariables = Exact<{
  productId: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProductPageQuery = { v1: { product: { allowCustomerReviews: boolean, approvedRatingSum: number, approvedTotalReviews: number, fullDescription: string | null, gtin: string | null, height: number, id: string, sku: string | null, length: number, manufacturerPartNumber: string | null, metaDescription: string | null, metaTitle: string | null, metaKeywords: string | null, name: string | null, seoName: string | null, partInterchange: Array<string>, shortDescription: string | null, weight: number, width: number, youtubeEmbedCode: string | null, categories: Array<{ category: { id: string, name: string, seoName: string | null } }>, machineModelFitment: Array<{ id: string, name: string, machineManufacturer: { name: string }, machineType: { name: string } }>, manufacturers: Array<{ displayOrder: number, manufacturer: { description: string | null, name: string, picture: { imageUrl: string, thumbnail: { url: string } | null } | null } }>, pictures: Array<{ displayOrder: number, picture: { altAttribute: string | null, id: string, imageUrl: string, mimeType: string, seoFilename: string | null, size: number | null, titleAttribute: string | null, thumbnail: { size: number, url: string } | null, thumbnails: Array<{ size: number, url: string }> } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null }, specificationAttributes: Array<{ showOnProductPage: boolean, customValue: string | null, displayOrder: number, specificationAttributeOption: { id: string, colorSquaresRgb: string | null, name: string, specificationAttribute: { id: string, name: string } } }>, vendor: { description: string | null, displayOrder: number, email: string | null, id: string, metaDescription: string | null, metaKeywords: string | null, metaTitle: string | null, name: string, address: { address1: string | null, address2: string | null, city: string | null, company: string | null, createdOnUtc: string, email: string | null, firstName: string, id: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string }, stateProvince: { id: string } | null } | null, picture: { id: string } | null } | null }, diagrams: Array<{ id: string, imageUrl: string | null, machineSection: { id: string, seoName: string | null, title: string, machineModel: { id: string, name: string, machineManufacturer: { name: string } } } }> } };

export type ProductPageRelatedQueryVariables = Exact<{
  productId: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProductPageRelatedQuery = { v1: { product: { relatedProducts: Array<{ displayOrder: number, product: { id: string, name: string | null, seoName: string | null, approvedRatingSum: number, approvedTotalReviews: number, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null }, picture: { thumbnail: { url: string } | null } | null } }> } } };

export type ProductPageReviewsQueryVariables = Exact<{
  productId: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProductPageReviewsQuery = { v1: { product: { reviews: { totalCount: number | null, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null }, items: Array<{ createdOnUtc: string, helpfulNoTotal: number, helpfulYesTotal: number, id: string, rating: number, replyText: string | null, reviewText: string, title: string }> } } } };

export type ProductShippingMethodsQueryVariables = Exact<{
  productId: InputMaybe<Scalars['ID']['input']>;
  countryId: Scalars['ID']['input'];
  provinceId: InputMaybe<Scalars['ID']['input']>;
  postalCode: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductShippingMethodsQuery = { v1: { product: { shippingOptions: Array<{ name: string, price: number, eta: string | null }> } } };

export type QrCodeQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type QrCodeQuery = { v1: { product: { id: string, seoName: string | null } } };

export type ReviewQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type ReviewQuery = { v1: { my: { review: { createdOnUtc: string, helpfulNoTotal: number, helpfulYesTotal: number, id: string, rating: number, replyText: string | null, reviewText: string, title: string, suggestion: string, asDescribed: boolean | null, arrivedOnTime: boolean | null, promptService: boolean | null, wellPackaged: boolean | null, orderId: number | null } | null } | null } };

export type SearchFilterQueryVariables = Exact<{
  searchString: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<Array<IdAndValuesGraph> | IdAndValuesGraph>;
}>;


export type SearchFilterQuery = { v1: { searchResults: { filters: Array<{ id: string, name: string, values: Array<{ id: string, name: string, quantity: number }> }> } } };

export type SearchProductsBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type SearchProductsBySkuQuery = { v1: { product: { id: string, name: string | null, sku: string | null, manufacturerPartNumber: string | null, priceAndAvailability: { price: number | null, status: AvailabilityStatusEnum, stock: number | null }, picture: { thumbnail: { url: string } | null } | null } } };

export type SearchQueryVariables = Exact<{
  searchString: InputMaybe<Scalars['String']['input']>;
  sortMethod: InputMaybe<SortMethodEnum>;
  filters: InputMaybe<Array<IdAndValuesGraph> | IdAndValuesGraph>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchQuery = { v1: { searchResults: { productsConnection: { totalCount: number, items: Array<{ additionalShippingCharge: number, approvedRatingSum: number, approvedTotalReviews: number, id: string, isFreeShipping: boolean, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, partInterchange: Array<string>, showOnHomePage: boolean, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null, canNotify: boolean }, picture: { thumbnail: { url: string } | null } | null, warehouse: { address: { city: string | null, stateProvince: { abbreviation: string | null } | null } | null } | null }>, pageInfo: { startCursor: string | null, endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } } };

export type SearchFiltersQueryVariables = Exact<{
  searchString: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<Array<IdAndValuesGraph> | IdAndValuesGraph>;
}>;


export type SearchFiltersQuery = { v1: { searchResults: { filters: Array<{ id: string, name: string, values: Array<{ id: string, name: string, quantity: number }> }> } } };

export type SimilarItemsSearchQueryVariables = Exact<{
  relatedManufacturerPartNumber: InputMaybe<Scalars['String']['input']>;
  sortMethod: InputMaybe<SortMethodEnum>;
  filters: InputMaybe<Array<IdAndValuesGraph> | IdAndValuesGraph>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
}>;


export type SimilarItemsSearchQuery = { v1: { searchResults: { productsConnection: { items: Array<{ approvedRatingSum: number, approvedTotalReviews: number, id: string, isFreeShipping: boolean, manufacturerPartNumber: string | null, name: string | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { price: number | null, status: AvailabilityStatusEnum, stock: number | null }, picture: { thumbnail: { url: string } | null } | null }> } } } };

export type ShoppingCartAppliedDiscountsQueryVariables = Exact<{
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
}>;


export type ShoppingCartAppliedDiscountsQuery = { v1: { my: { shoppingCartAppliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }> } | null } };

export type ShoppingCartPartialFieldsFragment = { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> };

export type ShoppingCartPartialWithReturnShippingMethodsFieldsFragment = { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }>, shippingMethods: Array<{ eta: string | null, id: string, name: string, price: number, selected: boolean }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> };

export type ShoppingCartQueryVariables = Exact<{
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
}>;


export type ShoppingCartQuery = { v1: { my: { shoppingCart: { errors: Array<string>, estimatedItemTaxRate: number | null, estimatedShippingTaxRate: number | null, itemCount: number, poNumber: string | null, warnings: Array<string>, destination: { city: string | null, countryId: string, postalCode: string | null, provinceId: string | null }, appliedDiscounts: Array<{ name: string, couponCode: string | null, discountAmount: number, discountType: DiscountType }>, productGroups: Array<{ shippingProfileId: string, vendorId: string, warehouseId: string, backordered: boolean, shoppingCartItemId: string | null, items: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> }>, savedForLaterItems: Array<{ id: string, quantity: number, reference: string | null, backordered: boolean, price: number | null, quoteId: string | null, product: { id: string, manufacturerPartNumber: string | null, name: string | null, seoName: string | null, sku: string | null, isTaxExempt: boolean, picture: { thumbnail: { url: string } | null } | null, vendor: { name: string } | null, manufacturers: Array<{ manufacturer: { name: string } }>, priceAndAvailability: { allowedQuantities: string | null, backorderAvailabilityRange: string | null, canNotify: boolean, oldPrice: number | null, orderMaximumQuantity: number, orderMinimumQuantity: number, preorderAvailabilityStartDateTime: string | null, price: number | null, status: AvailabilityStatusEnum, stock: number | null } } }> } } | null } };

export type ShoppingCartShippingMethodsQueryVariables = Exact<{
  countryId: Scalars['ID']['input'];
  provinceId: InputMaybe<Scalars['ID']['input']>;
  postalCode: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
  shippingProfileId: Scalars['ID']['input'];
  backordered: Scalars['Boolean']['input'];
  quoteGuid: InputMaybe<Scalars['Guid']['input']>;
  shoppingCartItemId: InputMaybe<Scalars['ID']['input']>;
}>;


export type ShoppingCartShippingMethodsQuery = { v1: { my: { shoppingCartShippingMethods: Array<{ id: string, name: string, price: number, selected: boolean, eta: string | null }> } | null } };

export type ThankYouPageQueryVariables = Exact<{
  clubOrderGuid: Scalars['Guid']['input'];
}>;


export type ThankYouPageQuery = { v1: { order: Array<{ canRegister: boolean, cardName: string | null, cardType: string | null, customOrderNumber: string | null, estArrivalDate: string | null, orderGuid: string, maskedCreditCardNumber: string | null, orderShippingExclTax: number, orderShippingInclTax: number, orderSubtotalExclTax: number, orderSubtotalInclTax: number, orderSubtotalDiscountExclTax: number, orderSubtotalDiscountInclTax: number, orderTax: number, orderDiscountInclTax: number, orderDiscountExclTax: number, orderTotal: number, purchaseOrder: string | null, zboxShippingMethod: string | null, billingAddress: { address1: string | null, address2: string | null, city: string | null, company: string | null, email: string | null, firstName: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string, name: string }, stateProvince: { id: string, name: string, abbreviation: string | null } | null }, orderItems: Array<{ backorderedWhenOrdered: boolean, quantity: number, reference: string | null, unitPriceExclTax: number, product: { id: string, name: string | null, seoName: string | null, manufacturers: Array<{ manufacturer: { name: string } }>, picture: { thumbnail: { url: string } | null } | null, priceAndAvailability: { price: number | null, status: AvailabilityStatusEnum }, vendor: { name: string } | null } }>, shippingAddress: { address1: string | null, address2: string | null, city: string | null, company: string | null, email: string | null, firstName: string, lastName: string, phoneNumber: string | null, zipPostalCode: string | null, country: { id: string, name: string }, stateProvince: { id: string, name: string, abbreviation: string | null } | null } | null, usedDiscounts: Array<{ discount: { name: string, couponCode: string | null, discountType: DiscountType } }> }> } };

export type ValidateProductIdQueryVariables = Exact<{
  productId: InputMaybe<Scalars['ID']['input']>;
}>;


export type ValidateProductIdQuery = { v1: { product: { id: string } } };

export type WarehouseQueryVariables = Exact<{
  productId: InputMaybe<Scalars['ID']['input']>;
}>;


export type WarehouseQuery = { v1: { product: { warehouse: { id: string, name: string, address: { address1: string | null, address2: string | null, city: string | null, zipPostalCode: string | null, phoneNumber: string | null, country: { id: string }, stateProvince: { id: string, name: string } | null } | null } | null } } };

export type ZipCodeTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type ZipCodeTemplateQuery = { v1: { info: { zipCodeTemplate: string } } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];

  constructor(private value: string, public __meta__?: Record<string, any> | undefined) {
    super(value);
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const OrderPartialQueryFragmentFragmentDoc = new TypedDocumentString(`
    fragment OrderPartialQueryFragment on OrderGraph {
  id
  customerId
  isGuestOrder
  canRegister
  canRequestReturn
  canCancelOrder
  billingAddress {
    address1
    address2
    city
    company
    country {
      id
    }
    email
    firstName
    lastName
    phoneNumber
    stateProvince {
      id
    }
    zipPostalCode
  }
  createdOnUtc
  customOrderNumber
  clubOrderGuid
  estArrivalDate
  purchaseOrder
  orderItems {
    orderItemGuid
    id
    product {
      id
      name
      reviews {
        totalCount
      }
      seoName
      additionalShippingCharge
      manufacturerPartNumber
      manufacturers {
        displayOrder
        manufacturer {
          displayOrder
          id
          name
          picture {
            imageUrl
          }
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
        canNotify
      }
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      shipSeparately
      sku
      vendor {
        name
      }
    }
    quantity
    unitPriceExclTax
    reference
  }
  orderStatus
  orderTotal
  paymentStatus
  shipments {
    id
    deliveryDateUtc
    shipmentItems {
      id
      quantity
      orderItem {
        id
      }
    }
    shippedDateUtc
    totalWeight
    trackingNumber
    trackingNumberUrl
  }
  shippingAddress {
    address1
    address2
    city
    company
    country {
      id
    }
    email
    firstName
    lastName
    phoneNumber
    stateProvince {
      id
    }
    zipPostalCode
  }
  zboxShippingMethod
  shippingStatus
}
    `, {"fragmentName":"OrderPartialQueryFragment"}) as unknown as TypedDocumentString<OrderPartialQueryFragmentFragment, unknown>;
export const ShoppingCartPartialFieldsFragmentDoc = new TypedDocumentString(`
    fragment ShoppingCartPartialFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}
    `, {"fragmentName":"ShoppingCartPartialFields"}) as unknown as TypedDocumentString<ShoppingCartPartialFieldsFragment, unknown>;
export const ShoppingCartPartialWithReturnShippingMethodsFieldsFragmentDoc = new TypedDocumentString(`
    fragment ShoppingCartPartialWithReturnShippingMethodsFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
    shippingMethods(
      countryId: $countryId
      provinceId: $stateProvinceId
      postalCode: $postalCode
      quoteGuid: $quoteGuid
    ) {
      eta
      id
      name
      price
      selected
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}
    `, {"fragmentName":"ShoppingCartPartialWithReturnShippingMethodsFields"}) as unknown as TypedDocumentString<ShoppingCartPartialWithReturnShippingMethodsFieldsFragment, unknown>;
export const RecentlyViewedSearchResultsDocument = new TypedDocumentString(`
    query RecentlyViewedSearchResults($filters: [IdAndValuesGraph!]) {
  v1 {
    searchResults(filters: $filters) {
      productsConnection {
        items {
          id
          name
          seoName
          picture {
            imageUrl
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RecentlyViewedSearchResultsQuery, RecentlyViewedSearchResultsQueryVariables>;
export const AddAddressDocument = new TypedDocumentString(`
    mutation AddAddress($address: AddressInputGraph!) {
  v1 {
    shippingAddress {
      add(address: $address) {
        id
        country {
          id
          name
        }
        firstName
        lastName
        company
        email
        address1
        address2
        city
        stateProvince {
          id
          name
          abbreviation
        }
        zipPostalCode
        phoneNumber
        createdOnUtc
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AddAddressMutation, AddAddressMutationVariables>;
export const AddCouponDocument = new TypedDocumentString(`
    mutation AddCoupon($couponCode: String!, $quoteGuid: Guid) {
  v1 {
    cart {
      addCoupon(couponCode: $couponCode, quoteGuid: $quoteGuid) {
        ...ShoppingCartPartialFields
      }
    }
  }
}
    fragment ShoppingCartPartialFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}`) as unknown as TypedDocumentString<AddCouponMutation, AddCouponMutationVariables>;
export const AddFeedbackDocument = new TypedDocumentString(`
    mutation AddFeedback($feedback: FeedbackInputGraph!) {
  v1 {
    leaveFeedback {
      add(feedback: $feedback)
    }
  }
}
    `) as unknown as TypedDocumentString<AddFeedbackMutation, AddFeedbackMutationVariables>;
export const AddPaymentDocument = new TypedDocumentString(`
    mutation AddPayment($address: AddressInputGraph!, $paymentType: PaymentTypeEnum!, $nonce: String!, $deviceData: String!, $captchaResponse: String) {
  v1 {
    paymentMethod {
      add(
        address: $address
        paymentType: $paymentType
        nonce: $nonce
        deviceData: $deviceData
        captchaResponse: $captchaResponse
      ) {
        id
        accountNameOrEmail
        address {
          id
          country {
            id
            name
          }
          firstName
          lastName
          company
          email
          address1
          address2
          city
          stateProvince {
            id
            name
            abbreviation
          }
          zipPostalCode
          phoneNumber
          createdOnUtc
        }
        paymentType
        creditCardType
        creditCardLast4
        creditCardExp
        displayOrder
        createdOnUtc
        validShippingAddresses {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AddPaymentMutation, AddPaymentMutationVariables>;
export const AddProductToCartFromCatalogDocument = new TypedDocumentString(`
    mutation AddProductToCartFromCatalog($productId: ID!, $shoppingCartTypeId: ID!, $qty: Int!) {
  v1 {
    cart {
      add(productId: $productId, shoppingCartTypeId: $shoppingCartTypeId, qty: $qty) {
        ...ShoppingCartPartialFields
      }
    }
  }
}
    fragment ShoppingCartPartialFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}`) as unknown as TypedDocumentString<AddProductToCartFromCatalogMutation, AddProductToCartFromCatalogMutationVariables>;
export const AddQuoteDocument = new TypedDocumentString(`
    mutation AddQuote($quote: QuoteInputGraph!) {
  v1 {
    quote {
      add(quote: $quote) {
        id
        guid
        title
        createdOnUtc
        expirationDate
        canOrder
        items {
          id
          productId
          quantity
          price
          reference
          backordered
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AddQuoteMutation, AddQuoteMutationVariables>;
export const CancelOrderDocument = new TypedDocumentString(`
    mutation CancelOrder($id: ID!) {
  v1 {
    order {
      cancelOrder(id: $id)
    }
  }
}
    `) as unknown as TypedDocumentString<CancelOrderMutation, CancelOrderMutationVariables>;
export const CartSetDestinationExternalPaymentDocument = new TypedDocumentString(`
    mutation CartSetDestinationExternalPayment($countryId: ID!, $stateProvinceId: ID, $postalCode: String, $quoteGuid: Guid) {
  v1 {
    cart {
      setDestination(
        countryId: $countryId
        stateProvinceId: $stateProvinceId
        postalCode: $postalCode
        quoteGuid: $quoteGuid
      ) {
        ...ShoppingCartPartialWithReturnShippingMethodsFields
      }
    }
  }
}
    fragment ShoppingCartPartialWithReturnShippingMethodsFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
    shippingMethods(
      countryId: $countryId
      provinceId: $stateProvinceId
      postalCode: $postalCode
      quoteGuid: $quoteGuid
    ) {
      eta
      id
      name
      price
      selected
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}`) as unknown as TypedDocumentString<CartSetDestinationExternalPaymentMutation, CartSetDestinationExternalPaymentMutationVariables>;
export const CartSetDestinationDocument = new TypedDocumentString(`
    mutation CartSetDestination($countryId: ID!, $stateProvinceId: ID, $postalCode: String, $quoteGuid: Guid) {
  v1 {
    cart {
      setDestination(
        countryId: $countryId
        stateProvinceId: $stateProvinceId
        postalCode: $postalCode
        quoteGuid: $quoteGuid
      ) {
        ...ShoppingCartPartialFields
      }
    }
  }
}
    fragment ShoppingCartPartialFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}`) as unknown as TypedDocumentString<CartSetDestinationMutation, CartSetDestinationMutationVariables>;
export const CartSetLineReferenceDocument = new TypedDocumentString(`
    mutation CartSetLineReference($shoppingCartItemId: ID!, $reference: String!, $shoppingCartTypeId: ID!, $quoteGuid: Guid) {
  v1 {
    cart {
      setLineReference(
        shoppingCartItemId: $shoppingCartItemId
        reference: $reference
        shoppingCartTypeId: $shoppingCartTypeId
        quoteGuid: $quoteGuid
      ) {
        ...ShoppingCartPartialFields
      }
    }
  }
}
    fragment ShoppingCartPartialFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}`) as unknown as TypedDocumentString<CartSetLineReferenceMutation, CartSetLineReferenceMutationVariables>;
export const ChangeFeedbackNameDocument = new TypedDocumentString(`
    mutation ChangeFeedbackName($feedbackName: String!) {
  v1 {
    loginAndSecurity {
      changeFeedbackName(feedbackName: $feedbackName)
    }
  }
}
    `) as unknown as TypedDocumentString<ChangeFeedbackNameMutation, ChangeFeedbackNameMutationVariables>;
export const ChangeNameDocument = new TypedDocumentString(`
    mutation ChangeName($firstName: String!, $lastName: String!) {
  v1 {
    loginAndSecurity {
      changeName(firstName: $firstName, lastName: $lastName)
    }
  }
}
    `) as unknown as TypedDocumentString<ChangeNameMutation, ChangeNameMutationVariables>;
export const ChangeNumberDocument = new TypedDocumentString(`
    mutation ChangeNumber($phoneNumber: String!) {
  v1 {
    loginAndSecurity {
      changeNumber(phoneNumber: $phoneNumber)
    }
  }
}
    `) as unknown as TypedDocumentString<ChangeNumberMutation, ChangeNumberMutationVariables>;
export const ChangeQuantityInCartDocument = new TypedDocumentString(`
    mutation ChangeQuantityInCart($shoppingCartItemId: ID!, $shoppingCartTypeId: ID!, $qty: Int!) {
  v1 {
    cart {
      changeQuantity(
        shoppingCartItemId: $shoppingCartItemId
        shoppingCartTypeId: $shoppingCartTypeId
        qty: $qty
      ) {
        ...ShoppingCartPartialFields
      }
    }
  }
}
    fragment ShoppingCartPartialFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}`) as unknown as TypedDocumentString<ChangeQuantityInCartMutation, ChangeQuantityInCartMutationVariables>;
export const CheckoutExternalPaymentDocument = new TypedDocumentString(`
    mutation CheckoutExternalPayment($email: String, $nonce: String!, $shippingAddress: AddressInputGraph!, $billingAddress: AddressInputGraph!, $cart: ShoppingCartInputGraph!, $deviceData: String!, $paymentType: PaymentTypeEnum!, $captchaResponse: String) {
  v1 {
    cart {
      placeOrderExternalPayment(
        email: $email
        nonce: $nonce
        shippingAddress: $shippingAddress
        billingAddress: $billingAddress
        cart: $cart
        deviceData: $deviceData
        paymentType: $paymentType
        captchaResponse: $captchaResponse
      )
    }
  }
}
    `) as unknown as TypedDocumentString<CheckoutExternalPaymentMutation, CheckoutExternalPaymentMutationVariables>;
export const CheckoutDocument = new TypedDocumentString(`
    mutation Checkout($shippingAddressId: ID!, $paymentMethodId: ID!, $cart: ShoppingCartInputGraph!, $email: String, $deviceData: String!, $captchaResponse: String) {
  v1 {
    cart {
      placeOrder(
        shippingAddressId: $shippingAddressId
        paymentMethodId: $paymentMethodId
        cart: $cart
        email: $email
        deviceData: $deviceData
        captchaResponse: $captchaResponse
      )
    }
  }
}
    `) as unknown as TypedDocumentString<CheckoutMutation, CheckoutMutationVariables>;
export const DeleteAddressDocument = new TypedDocumentString(`
    mutation DeleteAddress($addressId: ID!) {
  v1 {
    shippingAddress {
      delete(id: $addressId)
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteAddressMutation, DeleteAddressMutationVariables>;
export const DeletePaymentDocument = new TypedDocumentString(`
    mutation DeletePayment($paymentId: ID!) {
  v1 {
    paymentMethod {
      delete(id: $paymentId)
    }
  }
}
    `) as unknown as TypedDocumentString<DeletePaymentMutation, DeletePaymentMutationVariables>;
export const EditAddressDocument = new TypedDocumentString(`
    mutation EditAddress($addressId: ID!, $address: AddressInputGraph!) {
  v1 {
    shippingAddress {
      edit(id: $addressId, address: $address) {
        id
        country {
          id
          name
        }
        firstName
        lastName
        company
        email
        address1
        address2
        city
        stateProvince {
          id
          name
          abbreviation
        }
        zipPostalCode
        phoneNumber
        createdOnUtc
      }
    }
  }
}
    `) as unknown as TypedDocumentString<EditAddressMutation, EditAddressMutationVariables>;
export const EditPaymentDocument = new TypedDocumentString(`
    mutation EditPayment($paymentId: ID!, $address: AddressInputGraph, $nonce: String!, $deviceData: String!, $captchaResponse: String) {
  v1 {
    paymentMethod {
      edit(
        id: $paymentId
        address: $address
        nonce: $nonce
        deviceData: $deviceData
        captchaResponse: $captchaResponse
      ) {
        id
        accountNameOrEmail
        address {
          id
          country {
            id
            name
          }
          firstName
          lastName
          company
          email
          address1
          address2
          city
          stateProvince {
            id
            name
            abbreviation
          }
          zipPostalCode
          phoneNumber
          createdOnUtc
        }
        paymentType
        creditCardType
        creditCardLast4
        creditCardExp
        displayOrder
        createdOnUtc
        validShippingAddresses {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<EditPaymentMutation, EditPaymentMutationVariables>;
export const AddMachineDocument = new TypedDocumentString(`
    mutation AddMachine($garageItem: GarageInputGraph!, $setSelected: Boolean!) {
  v1 {
    garage {
      add(garageItem: $garageItem, setSelected: $setSelected) {
        id
        hours
        machineAttachment {
          id
          name
        }
        machineEngine {
          id
          name
        }
        machineModel {
          baseName
          name
          id
          machineEngines {
            id
            name
          }
          machineManufacturer {
            id
            name
          }
          machineType {
            id
            name
          }
          picture {
            id
            imageUrl
            thumbnail(size: 100) {
              url
            }
          }
        }
        machineStatus
        name
        notes
        serialNumber
        sortOrder
        stockNumber
        year
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AddMachineMutation, AddMachineMutationVariables>;
export const CheckFitmentDocument = new TypedDocumentString(`
    mutation CheckFitment($productId: ID!, $garageId: ID!) {
  v1 {
    garage {
      fitmentCheck(garageId: $garageId, productId: $productId)
    }
  }
}
    `) as unknown as TypedDocumentString<CheckFitmentMutation, CheckFitmentMutationVariables>;
export const ClearMachineDocument = new TypedDocumentString(`
    mutation ClearMachine($garageId: ID!) {
  v1 {
    garage {
      clearPicture(garageId: $garageId) {
        id
        name
        picture {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClearMachineMutation, ClearMachineMutationVariables>;
export const DeleteMachineDocument = new TypedDocumentString(`
    mutation DeleteMachine($garageId: ID!) {
  v1 {
    garage {
      delete(garageId: $garageId)
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteMachineMutation, DeleteMachineMutationVariables>;
export const EditMachineDocument = new TypedDocumentString(`
    mutation EditMachine($garageId: ID!, $garageItem: GarageInputGraph!) {
  v1 {
    garage {
      edit(garageId: $garageId, garageItem: $garageItem) {
        id
        hours
        machineAttachment {
          id
        }
        machineEngine {
          id
          name
        }
        machineModel {
          baseName
          name
          id
          machineEngines {
            id
            name
          }
          machineManufacturer {
            id
            name
          }
          machineType {
            id
            name
          }
          picture {
            id
            imageUrl
            thumbnail(size: 100) {
              url
            }
          }
        }
        machineStatus
        name
        notes
        serialNumber
        sortOrder
        stockNumber
        year
      }
    }
  }
}
    `) as unknown as TypedDocumentString<EditMachineMutation, EditMachineMutationVariables>;
export const SetMachinePictureDocument = new TypedDocumentString(`
    mutation SetMachinePicture($garageId: ID!, $url: String, $base64PictureData: String, $mimeType: String) {
  v1 {
    garage {
      setPicture(
        garageId: $garageId
        url: $url
        base64PictureData: $base64PictureData
        mimeType: $mimeType
      ) {
        id
        picture {
          id
          imageUrl
          mimeType
          seoFilename
          size
          thumbnail(size: 100) {
            size
            url
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SetMachinePictureMutation, SetMachinePictureMutationVariables>;
export const SetMachineDocument = new TypedDocumentString(`
    mutation SetMachine($id: ID) {
  v1 {
    garage {
      setSelected(garageId: $id)
    }
  }
}
    `) as unknown as TypedDocumentString<SetMachineMutation, SetMachineMutationVariables>;
export const MoveToCartDocument = new TypedDocumentString(`
    mutation MoveToCart($shoppingCartItemId: ID!) {
  v1 {
    cart {
      moveToCart(shoppingCartItemId: $shoppingCartItemId) {
        ...ShoppingCartPartialFields
      }
    }
  }
}
    fragment ShoppingCartPartialFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}`) as unknown as TypedDocumentString<MoveToCartMutation, MoveToCartMutationVariables>;
export const RemoveCouponDocument = new TypedDocumentString(`
    mutation RemoveCoupon($couponCode: String!, $quoteGuid: Guid) {
  v1 {
    cart {
      removeCoupon(couponCode: $couponCode, quoteGuid: $quoteGuid) {
        ...ShoppingCartPartialFields
      }
    }
  }
}
    fragment ShoppingCartPartialFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}`) as unknown as TypedDocumentString<RemoveCouponMutation, RemoveCouponMutationVariables>;
export const RemoveProductFromCartDocument = new TypedDocumentString(`
    mutation RemoveProductFromCart($shoppingCartItemId: ID!, $shoppingCartTypeId: ID!) {
  v1 {
    cart {
      remove(
        shoppingCartItemId: $shoppingCartItemId
        shoppingCartTypeId: $shoppingCartTypeId
      ) {
        ...ShoppingCartPartialFields
      }
    }
  }
}
    fragment ShoppingCartPartialFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}`) as unknown as TypedDocumentString<RemoveProductFromCartMutation, RemoveProductFromCartMutationVariables>;
export const SaveForLaterProductDocument = new TypedDocumentString(`
    mutation SaveForLaterProduct($shoppingCartItemId: ID!) {
  v1 {
    cart {
      saveForLater(shoppingCartItemId: $shoppingCartItemId) {
        ...ShoppingCartPartialFields
      }
    }
  }
}
    fragment ShoppingCartPartialFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}`) as unknown as TypedDocumentString<SaveForLaterProductMutation, SaveForLaterProductMutationVariables>;
export const SetDefaultAddressDocument = new TypedDocumentString(`
    mutation SetDefaultAddress($addressId: ID!) {
  v1 {
    shippingAddress {
      setDefault(id: $addressId)
    }
  }
}
    `) as unknown as TypedDocumentString<SetDefaultAddressMutation, SetDefaultAddressMutationVariables>;
export const SetDefaultPaymentDocument = new TypedDocumentString(`
    mutation SetDefaultPayment($paymentId: ID!) {
  v1 {
    paymentMethod {
      setDefault(id: $paymentId)
    }
  }
}
    `) as unknown as TypedDocumentString<SetDefaultPaymentMutation, SetDefaultPaymentMutationVariables>;
export const SetSelectedShippingMethodDocument = new TypedDocumentString(`
    mutation SetSelectedShippingMethod($countryId: ID!, $provinceId: ID, $postalCode: String, $warehouseId: ID!, $vendorId: ID!, $shippingProfileId: ID!, $backordered: Boolean!, $selectedShippingMethodId: ID!, $quoteGuid: Guid, $shoppingCartItemId: ID) {
  v1 {
    cart {
      setSelectedShippingMethod(
        countryId: $countryId
        provinceId: $provinceId
        postalCode: $postalCode
        warehouseId: $warehouseId
        vendorId: $vendorId
        shippingProfileId: $shippingProfileId
        backordered: $backordered
        selectedShippingMethodId: $selectedShippingMethodId
        quoteGuid: $quoteGuid
        shoppingCartItemId: $shoppingCartItemId
      ) {
        eta
        id
        name
        price
        selected
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SetSelectedShippingMethodMutation, SetSelectedShippingMethodMutationVariables>;
export const SubmitReturnRequestDocument = new TypedDocumentString(`
    mutation SubmitReturnRequest($orderId: ID!, $reason: String!) {
  v1 {
    order {
      submitReturnRequest(orderId: $orderId, reason: $reason)
    }
  }
}
    `) as unknown as TypedDocumentString<SubmitReturnRequestMutation, SubmitReturnRequestMutationVariables>;
export const MachinePageMachineModelDocument = new TypedDocumentString(`
    query MachinePageMachineModel($id: ID!) {
  v1 {
    machineModel(id: $id) {
      id
      name
      baseName
      json
      picture {
        seoFilename
        mimeType
        thumbnail(size: 100) {
          url
        }
      }
      machineManufacturer {
        id
        name
      }
      machineType {
        id
        name
      }
      productsForMachine {
        id
        name
        seoName
        approvedRatingSum
        approvedTotalReviews
        categories {
          category {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMinimumQuantity
          orderMaximumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        picture {
          thumbnail(size: 100) {
            url
          }
        }
      }
      machineSections {
        diagrams {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<MachinePageMachineModelQuery, MachinePageMachineModelQueryVariables>;
export const CatsDocument = new TypedDocumentString(`
    query Cats {
  v1 {
    categories {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<CatsQuery, CatsQueryVariables>;
export const InfoDocument = new TypedDocumentString(`
    query Info {
  v1 {
    info {
      version
    }
  }
}
    `) as unknown as TypedDocumentString<InfoQuery, InfoQueryVariables>;
export const UseBookMarkDiagramDocument = new TypedDocumentString(`
    mutation UseBookMarkDiagram($diagramId: ID!, $favorite: Boolean!) {
  v1 {
    diagram {
      favoriteDiagram(diagramId: $diagramId, favorite: $favorite)
    }
  }
}
    `) as unknown as TypedDocumentString<UseBookMarkDiagramMutation, UseBookMarkDiagramMutationVariables>;
export const BookMarkedDiagramDocument = new TypedDocumentString(`
    query BookMarkedDiagram {
  v1 {
    my {
      customerDiagrams {
        relationType
        diagram {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BookMarkedDiagramQuery, BookMarkedDiagramQueryVariables>;
export const DiagramPageMachineSectionsDocument = new TypedDocumentString(`
    query DiagramPageMachineSections($id: ID!) {
  v1 {
    machineSections(machineModelId: $id) {
      id
      title
      parentSectionId
      description
      seoName
      diagrams {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DiagramPageMachineSectionsQuery, DiagramPageMachineSectionsQueryVariables>;
export const DiagramPageMachineModelDocument = new TypedDocumentString(`
    query DiagramPageMachineModel($modelId: ID!) {
  v1 {
    machineModel(id: $modelId) {
      id
      name
      machineManufacturer {
        name
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DiagramPageMachineModelQuery, DiagramPageMachineModelQueryVariables>;
export const DiagramPageDiagramsDocument = new TypedDocumentString(`
    query DiagramPageDiagrams($id: ID!) {
  v1 {
    diagrams(id: $id) {
      id
      imageUrl
      diagramLineItems {
        partDrawingIdentifier
        partNumber
        quantity
        quantity
        comment
        products {
          name
          priceAndAvailability {
            price
            status
            stock
          }
          categories {
            displayOrder
            category {
              name
            }
          }
          seoName
          id
        }
      }
      machineSection {
        title
        seoName
        machineModel {
          name
          id
        }
        machineSection {
          title
          seoName
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DiagramPageDiagramsQuery, DiagramPageDiagramsQueryVariables>;
export const LogDiagramDocument = new TypedDocumentString(`
    mutation LogDiagram($diagramId: ID!) {
  v1 {
    diagram {
      logDiagram(diagramId: $diagramId)
    }
  }
}
    `) as unknown as TypedDocumentString<LogDiagramMutation, LogDiagramMutationVariables>;
export const AddressBookDocument = new TypedDocumentString(`
    query AddressBook {
  v1 {
    my {
      shippingAddresses {
        id
        country {
          id
          name
        }
        firstName
        lastName
        company
        email
        address1
        address2
        city
        stateProvince {
          id
          name
          abbreviation
        }
        zipPostalCode
        phoneNumber
        createdOnUtc
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AddressBookQuery, AddressBookQueryVariables>;
export const AllCustomerReviewsDocument = new TypedDocumentString(`
    query AllCustomerReviews($productId: ID) {
  v1 {
    product(id: $productId) {
      reviews {
        items {
          createdOnUtc
          helpfulNoTotal
          helpfulYesTotal
          id
          rating
          replyText
          reviewText
          title
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AllCustomerReviewsQuery, AllCustomerReviewsQueryVariables>;
export const BraintreeClientTokenDocument = new TypedDocumentString(`
    query BraintreeClientToken {
  v1 {
    my {
      plugins {
        braintree {
          clientToken
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BraintreeClientTokenQuery, BraintreeClientTokenQueryVariables>;
export const CategoriesDocument = new TypedDocumentString(`
    query Categories {
  v1 {
    info {
      version
      zipCodeTemplate
    }
    categories {
      displayOrder
      numberOfProducts
      id
      name
      seoName
      parentCategoryId
      showOnHomePage
      picture {
        thumbnail(size: 100) {
          url
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CategoriesQuery, CategoriesQueryVariables>;
export const CountriesDocument = new TypedDocumentString(`
    query Countries {
  v1 {
    countries {
      displayOrder
      id
      name
      twoLetterIsoCode
      stateProvinces {
        abbreviation
        displayOrder
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CountriesQuery, CountriesQueryVariables>;
export const DefaultPaymentAndShippingDocument = new TypedDocumentString(`
    query DefaultPaymentAndShipping {
  v1 {
    my {
      defaultPaymentMethod {
        id
        accountNameOrEmail
        address {
          address1
          address2
          city
          company
          country {
            id
            name
          }
          createdOnUtc
          email
          firstName
          id
          lastName
          phoneNumber
          stateProvince {
            abbreviation
            id
            name
          }
          zipPostalCode
        }
        createdOnUtc
        creditCardExp
        creditCardLast4
        creditCardType
        displayOrder
        paymentType
        validShippingAddresses {
          id
        }
      }
      defaultShippingAddress {
        id
        address1
        address2
        city
        company
        country {
          id
          name
        }
        createdOnUtc
        email
        firstName
        id
        lastName
        phoneNumber
        stateProvince {
          abbreviation
          id
          name
        }
        zipPostalCode
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DefaultPaymentAndShippingQuery, DefaultPaymentAndShippingQueryVariables>;
export const EditMyShippingAddressDocument = new TypedDocumentString(`
    query EditMyShippingAddress($addressId: ID!) {
  v1 {
    my {
      shippingAddress(id: $addressId) {
        id
        country {
          id
          name
        }
        firstName
        lastName
        company
        email
        address1
        address2
        city
        stateProvince {
          id
          name
          abbreviation
        }
        zipPostalCode
        phoneNumber
        createdOnUtc
      }
    }
  }
}
    `) as unknown as TypedDocumentString<EditMyShippingAddressQuery, EditMyShippingAddressQueryVariables>;
export const EmailNotificationsDocument = new TypedDocumentString(`
    query EmailNotifications {
  isAuthenticated
  v1 {
    my {
      email
    }
  }
}
    `) as unknown as TypedDocumentString<EmailNotificationsQuery, EmailNotificationsQueryVariables>;
export const EmptyFiltersSearchResultsDocument = new TypedDocumentString(`
    query EmptyFiltersSearchResults($searchString: String, $filters: [IdAndValuesGraph!]) {
  v1 {
    searchResults(searchString: $searchString, filters: $filters) {
      emptyFilters {
        id
        name
        values {
          id
          name
          quantity
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<EmptyFiltersSearchResultsQuery, EmptyFiltersSearchResultsQueryVariables>;
export const FeedbackNameDocument = new TypedDocumentString(`
    query FeedbackName {
  v1 {
    my {
      feedbackName
    }
  }
}
    `) as unknown as TypedDocumentString<FeedbackNameQuery, FeedbackNameQueryVariables>;
export const FleetMachineDocument = new TypedDocumentString(`
    query FleetMachine {
  v1 {
    machineTypes {
      id
      name
    }
    machineAttachments {
      id
      name
    }
    machineManufacturers {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<FleetMachineQuery, FleetMachineQueryVariables>;
export const QueryMachineManufacturers2Document = new TypedDocumentString(`
    query QueryMachineManufacturers2 {
  v1 {
    machineManufacturers {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<QueryMachineManufacturers2Query, QueryMachineManufacturers2QueryVariables>;
export const QueryMachineManufacturersDocument = new TypedDocumentString(`
    query QueryMachineManufacturers($manufacturerId: ID!) {
  v1 {
    machineManufacturers(id: $manufacturerId) {
      name
      id
    }
    machineModels(machineManufacturerId: $manufacturerId) {
      id
      name
      baseName
      productsForMachine {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<QueryMachineManufacturersQuery, QueryMachineManufacturersQueryVariables>;
export const FleetQueryDocument = new TypedDocumentString(`
    query FleetQuery {
  v1 {
    my {
      selectedGarageItem {
        id
      }
      garage {
        id
        name
        orderItems {
          orderItemGuid
          id
          quantity
          unitPriceExclTax
          reference
          product {
            id
            name
            reviews {
              totalCount
            }
            seoName
            additionalShippingCharge
            manufacturerPartNumber
            manufacturers {
              displayOrder
              manufacturer {
                displayOrder
                id
                name
                picture {
                  imageUrl
                }
              }
            }
            priceAndAvailability {
              allowedQuantities
              backorderAvailabilityRange
              oldPrice
              orderMaximumQuantity
              orderMinimumQuantity
              preorderAvailabilityStartDateTime
              price
              status
              stock
              canNotify
            }
            picture {
              thumbnail(size: 100) {
                url
              }
            }
            shipSeparately
            sku
            vendor {
              name
            }
          }
          order {
            createdOnUtc
          }
        }
        hours
        machineAttachment {
          id
          name
        }
        machineEngine {
          id
          name
        }
        machineModel {
          id
          name
          baseName
          picture {
            seoFilename
            mimeType
            thumbnail(size: 100) {
              url
            }
          }
          machineManufacturer {
            id
            name
          }
          machineType {
            id
            name
          }
        }
        notes
        machineStatus
        picture {
          id
          imageUrl
          thumbnail(size: 100) {
            url
          }
        }
        serialNumber
        sortOrder
        stockNumber
        year
        engine
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FleetQueryQuery, FleetQueryQueryVariables>;
export const LeaveFeedbackDocument = new TypedDocumentString(`
    query LeaveFeedback($orderId: ID!) {
  v1 {
    my {
      order(id: $orderId) {
        createdOnUtc
        orderItems {
          id
          itemWeight
          orderItemGuid
          product {
            id
            name
            seoName
            additionalShippingCharge
            manufacturerPartNumber
            manufacturers {
              displayOrder
              manufacturer {
                displayOrder
                id
                name
                picture {
                  imageUrl
                }
              }
            }
            picture {
              thumbnail(size: 100) {
                url
              }
            }
            shipSeparately
            sku
            vendor {
              id
              name
            }
          }
          quantity
        }
        orderStatus
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LeaveFeedbackQuery, LeaveFeedbackQueryVariables>;
export const LoginAndSecurityDocument = new TypedDocumentString(`
    query LoginAndSecurity {
  isAuthenticated
  v1 {
    my {
      firstName
      lastName
      feedbackName
      email
      phoneNumber
    }
  }
}
    `) as unknown as TypedDocumentString<LoginAndSecurityQuery, LoginAndSecurityQueryVariables>;
export const MachineManufacturersDocument = new TypedDocumentString(`
    query MachineManufacturers($machineTypeId: ID, $diagramsRequired: Boolean) {
  v1 {
    machineManufacturers(
      machineTypeId: $machineTypeId
      diagramsRequired: $diagramsRequired
    ) {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<MachineManufacturersQuery, MachineManufacturersQueryVariables>;
export const MachineModels2Document = new TypedDocumentString(`
    query MachineModels2($manufacturerId: ID, $machineTypeId: ID) {
  v1 {
    machineModels(
      machineManufacturerId: $manufacturerId
      machineTypeId: $machineTypeId
    ) {
      id
      name
      baseName
      machineEngines {
        id
        name
      }
      machineManufacturer {
        id
        name
      }
      machineType {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<MachineModels2Query, MachineModels2QueryVariables>;
export const NavbarCartTotalDocument = new TypedDocumentString(`
    query NavbarCartTotal($quoteGuid: Guid) {
  v1 {
    my {
      shoppingCart(quoteGuid: $quoteGuid) {
        itemCount
      }
    }
  }
}
    `) as unknown as TypedDocumentString<NavbarCartTotalQuery, NavbarCartTotalQueryVariables>;
export const OrderDocument = new TypedDocumentString(`
    query Order($clubOrderGuid: Guid!) {
  v1 {
    order(clubOrderGuid: $clubOrderGuid) {
      ...OrderPartialQueryFragment
    }
  }
}
    fragment OrderPartialQueryFragment on OrderGraph {
  id
  customerId
  isGuestOrder
  canRegister
  canRequestReturn
  canCancelOrder
  billingAddress {
    address1
    address2
    city
    company
    country {
      id
    }
    email
    firstName
    lastName
    phoneNumber
    stateProvince {
      id
    }
    zipPostalCode
  }
  createdOnUtc
  customOrderNumber
  clubOrderGuid
  estArrivalDate
  purchaseOrder
  orderItems {
    orderItemGuid
    id
    product {
      id
      name
      reviews {
        totalCount
      }
      seoName
      additionalShippingCharge
      manufacturerPartNumber
      manufacturers {
        displayOrder
        manufacturer {
          displayOrder
          id
          name
          picture {
            imageUrl
          }
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
        canNotify
      }
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      shipSeparately
      sku
      vendor {
        name
      }
    }
    quantity
    unitPriceExclTax
    reference
  }
  orderStatus
  orderTotal
  paymentStatus
  shipments {
    id
    deliveryDateUtc
    shipmentItems {
      id
      quantity
      orderItem {
        id
      }
    }
    shippedDateUtc
    totalWeight
    trackingNumber
    trackingNumberUrl
  }
  shippingAddress {
    address1
    address2
    city
    company
    country {
      id
    }
    email
    firstName
    lastName
    phoneNumber
    stateProvince {
      id
    }
    zipPostalCode
  }
  zboxShippingMethod
  shippingStatus
}`) as unknown as TypedDocumentString<OrderQuery, OrderQueryVariables>;
export const OrderSummaryDocument = new TypedDocumentString(`
    query OrderSummary($orderId: ID!) {
  v1 {
    my {
      order(id: $orderId) {
        id
        billingAddress {
          address1
          address2
          city
          company
          country {
            id
          }
          email
          firstName
          lastName
          phoneNumber
          stateProvince {
            id
          }
          zipPostalCode
        }
        createdOnUtc
        customOrderNumber
        orderItems {
          id
          product {
            id
            name
            additionalShippingCharge
            manufacturerPartNumber
            approvedRatingSum
            approvedTotalReviews
            priceAndAvailability {
              allowedQuantities
              backorderAvailabilityRange
              canNotify
              oldPrice
              orderMinimumQuantity
              orderMaximumQuantity
              preorderAvailabilityStartDateTime
              price
              status
              stock
            }
            manufacturers {
              displayOrder
              manufacturer {
                displayOrder
                id
                name
                picture {
                  imageUrl
                }
              }
            }
            picture {
              thumbnail(size: 100) {
                url
              }
            }
            shipSeparately
            sku
            vendor {
              name
            }
          }
          quantity
        }
        orderTotal
        orderTax
        orderShippingExclTax
        orderShippingInclTax
        orderSubtotalExclTax
        orderSubtotalInclTax
        orderSubtotalDiscountExclTax
        orderSubtotalDiscountInclTax
        orderDiscountInclTax
        orderDiscountExclTax
        shipments {
          id
          deliveryDateUtc
          shipmentItems {
            id
            quantity
            orderItem {
              id
            }
          }
          shippedDateUtc
          totalWeight
          trackingNumber
        }
        shippingAddress {
          address1
          address2
          city
          company
          country {
            id
          }
          email
          firstName
          lastName
          phoneNumber
          stateProvince {
            id
          }
          zipPostalCode
        }
        usedDiscounts {
          discount {
            name
            couponCode
            discountType
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OrderSummaryQuery, OrderSummaryQueryVariables>;
export const OrdersAndReturnsQueryDocument = new TypedDocumentString(`
    query OrdersAndReturnsQuery {
  v1 {
    my {
      orders {
        totalCount
        pageInfo {
          endCursor
          startCursor
        }
        items {
          ...OrderPartialQueryFragment
        }
      }
    }
  }
}
    fragment OrderPartialQueryFragment on OrderGraph {
  id
  customerId
  isGuestOrder
  canRegister
  canRequestReturn
  canCancelOrder
  billingAddress {
    address1
    address2
    city
    company
    country {
      id
    }
    email
    firstName
    lastName
    phoneNumber
    stateProvince {
      id
    }
    zipPostalCode
  }
  createdOnUtc
  customOrderNumber
  clubOrderGuid
  estArrivalDate
  purchaseOrder
  orderItems {
    orderItemGuid
    id
    product {
      id
      name
      reviews {
        totalCount
      }
      seoName
      additionalShippingCharge
      manufacturerPartNumber
      manufacturers {
        displayOrder
        manufacturer {
          displayOrder
          id
          name
          picture {
            imageUrl
          }
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
        canNotify
      }
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      shipSeparately
      sku
      vendor {
        name
      }
    }
    quantity
    unitPriceExclTax
    reference
  }
  orderStatus
  orderTotal
  paymentStatus
  shipments {
    id
    deliveryDateUtc
    shipmentItems {
      id
      quantity
      orderItem {
        id
      }
    }
    shippedDateUtc
    totalWeight
    trackingNumber
    trackingNumberUrl
  }
  shippingAddress {
    address1
    address2
    city
    company
    country {
      id
    }
    email
    firstName
    lastName
    phoneNumber
    stateProvince {
      id
    }
    zipPostalCode
  }
  zboxShippingMethod
  shippingStatus
}`) as unknown as TypedDocumentString<OrdersAndReturnsQueryQuery, OrdersAndReturnsQueryQueryVariables>;
export const CustomerDiagramsDocument = new TypedDocumentString(`
    query CustomerDiagrams {
  v1 {
    my {
      customerDiagrams {
        id
        createdOnUtc
        relationType
        diagram {
          id
          machineSection {
            title
            seoName
            machineModel {
              id
              name
              machineManufacturer {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CustomerDiagramsQuery, CustomerDiagramsQueryVariables>;
export const MachineManufacturerWithModelDiagramsDocument = new TypedDocumentString(`
    query MachineManufacturerWithModelDiagrams($machineManufacturerId: ID!) {
  v1 {
    machineManufacturers(id: $machineManufacturerId, diagramsRequired: true) {
      id
      name
      machineModels(diagramsRequired: true) {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<MachineManufacturerWithModelDiagramsQuery, MachineManufacturerWithModelDiagramsQueryVariables>;
export const PaymentMethodDocument = new TypedDocumentString(`
    query PaymentMethod($paymentId: ID!) {
  v1 {
    my {
      paymentMethod(id: $paymentId) {
        id
        accountNameOrEmail
        address {
          id
          country {
            id
            name
          }
          firstName
          lastName
          company
          email
          address1
          address2
          city
          stateProvince {
            id
            name
            abbreviation
          }
          zipPostalCode
          phoneNumber
          createdOnUtc
        }
        paymentType
        creditCardType
        creditCardLast4
        creditCardExp
        displayOrder
        createdOnUtc
        validShippingAddresses {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PaymentMethodQuery, PaymentMethodQueryVariables>;
export const PaymentMethodsDocument = new TypedDocumentString(`
    query PaymentMethods {
  v1 {
    my {
      paymentMethods {
        id
        accountNameOrEmail
        address {
          id
          country {
            id
            name
          }
          firstName
          lastName
          company
          email
          address1
          address2
          city
          stateProvince {
            id
            name
            abbreviation
          }
          zipPostalCode
          phoneNumber
          createdOnUtc
        }
        paymentType
        creditCardType
        creditCardLast4
        creditCardExp
        displayOrder
        createdOnUtc
        validShippingAddresses {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const PreviouslyOrderedProductsDocument = new TypedDocumentString(`
    query PreviouslyOrderedProducts {
  v1 {
    my {
      orders {
        items {
          createdOnUtc
          orderItems {
            id
            product {
              seoName
              id
              name
              manufacturerPartNumber
              approvedRatingSum
              approvedTotalReviews
              priceAndAvailability {
                allowedQuantities
                backorderAvailabilityRange
                canNotify
                oldPrice
                orderMinimumQuantity
                orderMaximumQuantity
                preorderAvailabilityStartDateTime
                price
                status
                stock
              }
              manufacturers {
                displayOrder
                manufacturer {
                  displayOrder
                  id
                  name
                  picture {
                    imageUrl
                  }
                }
              }
              picture {
                thumbnail(size: 100) {
                  url
                }
              }
              shipSeparately
              sku
              vendor {
                name
              }
            }
            quantity
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PreviouslyOrderedProductsQuery, PreviouslyOrderedProductsQueryVariables>;
export const ProductPageAlsoPurchasedDocument = new TypedDocumentString(`
    query ProductPageAlsoPurchased($productId: ID) {
  v1 {
    product(id: $productId) {
      productsAlsoPurchased {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ProductPageAlsoPurchasedQuery, ProductPageAlsoPurchasedQueryVariables>;
export const ProductPageDocument = new TypedDocumentString(`
    query ProductPage($productId: ID) {
  v1 {
    product(id: $productId) {
      allowCustomerReviews
      approvedRatingSum
      approvedTotalReviews
      categories {
        category {
          id
          name
          seoName
        }
      }
      fullDescription
      gtin
      height
      id
      sku
      length
      machineModelFitment {
        id
        name
        machineManufacturer {
          name
        }
        machineType {
          name
        }
      }
      manufacturerPartNumber
      manufacturers {
        displayOrder
        manufacturer {
          description
          name
          picture {
            thumbnail(size: 100) {
              url
            }
            imageUrl
          }
        }
      }
      metaDescription
      metaTitle
      metaKeywords
      name
      seoName
      partInterchange
      pictures {
        displayOrder
        picture {
          altAttribute
          id
          imageUrl
          mimeType
          seoFilename
          size
          thumbnail(size: 100) {
            size
            url
          }
          thumbnails(sizes: [100, 500, 1600]) {
            size
            url
          }
          titleAttribute
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      seoName
      shortDescription
      specificationAttributes {
        showOnProductPage
        customValue
        displayOrder
        specificationAttributeOption {
          id
          colorSquaresRgb
          name
          specificationAttribute {
            id
            name
          }
        }
      }
      vendor {
        address {
          address1
          address2
          city
          company
          country {
            id
          }
          createdOnUtc
          email
          firstName
          id
          lastName
          phoneNumber
          stateProvince {
            id
          }
          zipPostalCode
        }
        description
        displayOrder
        email
        id
        metaDescription
        metaKeywords
        metaTitle
        name
        picture {
          id
        }
      }
      weight
      width
      youtubeEmbedCode
    }
    diagrams(productId: $productId) {
      id
      machineSection {
        id
        seoName
        title
        machineModel {
          id
          machineManufacturer {
            name
          }
          name
        }
      }
      imageUrl
    }
  }
}
    `) as unknown as TypedDocumentString<ProductPageQuery, ProductPageQueryVariables>;
export const ProductPageRelatedDocument = new TypedDocumentString(`
    query ProductPageRelated($productId: ID) {
  v1 {
    product(id: $productId) {
      relatedProducts {
        displayOrder
        product {
          id
          name
          seoName
          approvedRatingSum
          approvedTotalReviews
          priceAndAvailability {
            allowedQuantities
            backorderAvailabilityRange
            canNotify
            oldPrice
            orderMaximumQuantity
            orderMinimumQuantity
            preorderAvailabilityStartDateTime
            price
            status
            stock
          }
          picture {
            thumbnail(size: 100) {
              url
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ProductPageRelatedQuery, ProductPageRelatedQueryVariables>;
export const ProductPageReviewsDocument = new TypedDocumentString(`
    query ProductPageReviews($productId: ID) {
  v1 {
    product(id: $productId) {
      reviews {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        items {
          createdOnUtc
          helpfulNoTotal
          helpfulYesTotal
          id
          rating
          replyText
          reviewText
          title
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ProductPageReviewsQuery, ProductPageReviewsQueryVariables>;
export const ProductShippingMethodsDocument = new TypedDocumentString(`
    query ProductShippingMethods($productId: ID, $countryId: ID!, $provinceId: ID, $postalCode: String) {
  v1 {
    product(id: $productId) {
      shippingOptions(
        countryId: $countryId
        provinceId: $provinceId
        postalCode: $postalCode
      ) {
        name
        price
        eta
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ProductShippingMethodsQuery, ProductShippingMethodsQueryVariables>;
export const QrCodeDocument = new TypedDocumentString(`
    query QrCode($sku: String!) {
  v1 {
    product(sku: $sku) {
      id
      seoName
    }
  }
}
    `) as unknown as TypedDocumentString<QrCodeQuery, QrCodeQueryVariables>;
export const ReviewDocument = new TypedDocumentString(`
    query Review($productId: ID!) {
  v1 {
    my {
      review(productId: $productId) {
        createdOnUtc
        helpfulNoTotal
        helpfulYesTotal
        id
        rating
        replyText
        reviewText
        title
        suggestion
        asDescribed
        arrivedOnTime
        promptService
        wellPackaged
        orderId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ReviewQuery, ReviewQueryVariables>;
export const SearchFilterDocument = new TypedDocumentString(`
    query SearchFilter($searchString: String, $filters: [IdAndValuesGraph!]) {
  v1 {
    searchResults(searchString: $searchString, filters: $filters) {
      filters {
        id
        name
        values {
          id
          name
          quantity
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SearchFilterQuery, SearchFilterQueryVariables>;
export const SearchProductsBySkuDocument = new TypedDocumentString(`
    query SearchProductsBySku($sku: String!) {
  v1 {
    product(sku: $sku) {
      id
      name
      sku
      manufacturerPartNumber
      priceAndAvailability {
        price
        status
        stock
      }
      picture {
        thumbnail(size: 100) {
          url
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SearchProductsBySkuQuery, SearchProductsBySkuQueryVariables>;
export const SearchDocument = new TypedDocumentString(`
    query Search($searchString: String, $sortMethod: SortMethodEnum, $filters: [IdAndValuesGraph!], $first: Int, $last: Int, $before: String, $after: String) {
  v1 {
    searchResults(searchString: $searchString, filters: $filters) {
      productsConnection(
        first: $first
        last: $last
        before: $before
        after: $after
        sortMethod: $sortMethod
      ) {
        totalCount
        items {
          additionalShippingCharge
          approvedRatingSum
          approvedTotalReviews
          id
          isFreeShipping
          manufacturerPartNumber
          manufacturers {
            manufacturer {
              name
            }
          }
          name
          seoName
          partInterchange
          priceAndAvailability {
            allowedQuantities
            backorderAvailabilityRange
            oldPrice
            orderMaximumQuantity
            orderMinimumQuantity
            preorderAvailabilityStartDateTime
            price
            status
            stock
            canNotify
          }
          picture {
            thumbnail(size: 100) {
              url
            }
          }
          showOnHomePage
          warehouse {
            address {
              city
              stateProvince {
                abbreviation
              }
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SearchQuery, SearchQueryVariables>;
export const SearchFiltersDocument = new TypedDocumentString(`
    query SearchFilters($searchString: String, $filters: [IdAndValuesGraph!]) {
  v1 {
    searchResults(searchString: $searchString, filters: $filters) {
      filters {
        id
        name
        values {
          id
          name
          quantity
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SearchFiltersQuery, SearchFiltersQueryVariables>;
export const SimilarItemsSearchDocument = new TypedDocumentString(`
    query SimilarItemsSearch($relatedManufacturerPartNumber: String, $sortMethod: SortMethodEnum, $filters: [IdAndValuesGraph!], $first: Int, $last: Int, $before: String, $after: String) {
  v1 {
    searchResults(relatedManufacturerPartNumber: $relatedManufacturerPartNumber) {
      productsConnection(
        first: $first
        last: $last
        before: $before
        after: $after
        sortMethod: $sortMethod
      ) {
        items {
          approvedRatingSum
          approvedTotalReviews
          id
          isFreeShipping
          manufacturerPartNumber
          manufacturers {
            manufacturer {
              name
            }
          }
          name
          priceAndAvailability {
            price
            status
            stock
          }
          picture {
            thumbnail(size: 100) {
              url
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SimilarItemsSearchQuery, SimilarItemsSearchQueryVariables>;
export const ShoppingCartAppliedDiscountsDocument = new TypedDocumentString(`
    query ShoppingCartAppliedDiscounts($quoteGuid: Guid) {
  v1 {
    my {
      shoppingCartAppliedDiscounts(quoteGuid: $quoteGuid) {
        name
        couponCode
        discountAmount
        discountType
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ShoppingCartAppliedDiscountsQuery, ShoppingCartAppliedDiscountsQueryVariables>;
export const ShoppingCartDocument = new TypedDocumentString(`
    query ShoppingCart($quoteGuid: Guid) {
  v1 {
    my {
      shoppingCart(quoteGuid: $quoteGuid) {
        ...ShoppingCartPartialFields
      }
    }
  }
}
    fragment ShoppingCartPartialFields on ShoppingCartGraph {
  destination {
    city
    countryId
    postalCode
    provinceId
  }
  errors
  estimatedItemTaxRate
  estimatedShippingTaxRate
  itemCount
  poNumber
  warnings
  appliedDiscounts {
    name
    couponCode
    discountAmount
    discountType
  }
  productGroups {
    shippingProfileId
    vendorId
    warehouseId
    backordered
    shoppingCartItemId
    items {
      id
      quantity
      reference
      backordered
      price
      quoteId
      product {
        id
        manufacturerPartNumber
        name
        seoName
        picture {
          thumbnail(size: 100) {
            url
          }
        }
        vendor {
          name
        }
        manufacturers {
          manufacturer {
            name
          }
        }
        priceAndAvailability {
          allowedQuantities
          backorderAvailabilityRange
          canNotify
          oldPrice
          orderMaximumQuantity
          orderMinimumQuantity
          preorderAvailabilityStartDateTime
          price
          status
          stock
        }
        sku
        isTaxExempt
      }
    }
  }
  savedForLaterItems {
    id
    quantity
    reference
    backordered
    price
    quoteId
    product {
      id
      manufacturerPartNumber
      name
      seoName
      picture {
        thumbnail(size: 100) {
          url
        }
      }
      vendor {
        name
      }
      manufacturers {
        manufacturer {
          name
        }
      }
      priceAndAvailability {
        allowedQuantities
        backorderAvailabilityRange
        canNotify
        oldPrice
        orderMaximumQuantity
        orderMinimumQuantity
        preorderAvailabilityStartDateTime
        price
        status
        stock
      }
      sku
      isTaxExempt
    }
  }
}`) as unknown as TypedDocumentString<ShoppingCartQuery, ShoppingCartQueryVariables>;
export const ShoppingCartShippingMethodsDocument = new TypedDocumentString(`
    query ShoppingCartShippingMethods($countryId: ID!, $provinceId: ID, $postalCode: String, $warehouseId: ID!, $vendorId: ID!, $shippingProfileId: ID!, $backordered: Boolean!, $quoteGuid: Guid, $shoppingCartItemId: ID) {
  v1 {
    my {
      shoppingCartShippingMethods(
        countryId: $countryId
        provinceId: $provinceId
        postalCode: $postalCode
        warehouseId: $warehouseId
        vendorId: $vendorId
        shippingProfileId: $shippingProfileId
        backordered: $backordered
        quoteGuid: $quoteGuid
        shoppingCartItemId: $shoppingCartItemId
      ) {
        id
        name
        price
        selected
        eta
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ShoppingCartShippingMethodsQuery, ShoppingCartShippingMethodsQueryVariables>;
export const ThankYouPageDocument = new TypedDocumentString(`
    query ThankYouPage($clubOrderGuid: Guid!) {
  v1 {
    order(clubOrderGuid: $clubOrderGuid) {
      billingAddress {
        address1
        address2
        city
        company
        country {
          id
          name
        }
        email
        firstName
        lastName
        phoneNumber
        stateProvince {
          id
          name
          abbreviation
        }
        zipPostalCode
      }
      canRegister
      cardName
      cardType
      customOrderNumber
      estArrivalDate
      orderGuid
      orderItems {
        backorderedWhenOrdered
        quantity
        reference
        unitPriceExclTax
        product {
          id
          manufacturers {
            manufacturer {
              name
            }
          }
          name
          seoName
          picture {
            thumbnail(size: 100) {
              url
            }
          }
          priceAndAvailability {
            price
            status
          }
          vendor {
            name
          }
        }
      }
      maskedCreditCardNumber
      orderShippingExclTax
      orderShippingInclTax
      orderSubtotalExclTax
      orderSubtotalInclTax
      orderSubtotalDiscountExclTax
      orderSubtotalDiscountInclTax
      orderTax
      orderDiscountInclTax
      orderDiscountExclTax
      orderTotal
      purchaseOrder
      shippingAddress {
        address1
        address2
        city
        company
        country {
          id
          name
        }
        email
        firstName
        lastName
        phoneNumber
        stateProvince {
          id
          name
          abbreviation
        }
        zipPostalCode
      }
      usedDiscounts {
        discount {
          name
          couponCode
          discountType
        }
      }
      zboxShippingMethod
    }
  }
}
    `) as unknown as TypedDocumentString<ThankYouPageQuery, ThankYouPageQueryVariables>;
export const ValidateProductIdDocument = new TypedDocumentString(`
    query ValidateProductId($productId: ID) {
  v1 {
    product(id: $productId) {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<ValidateProductIdQuery, ValidateProductIdQueryVariables>;
export const WarehouseDocument = new TypedDocumentString(`
    query Warehouse($productId: ID) {
  v1 {
    product(id: $productId) {
      warehouse {
        id
        name
        address {
          address1
          address2
          city
          country {
            id
          }
          stateProvince {
            id
            name
          }
          zipPostalCode
          phoneNumber
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<WarehouseQuery, WarehouseQueryVariables>;
export const ZipCodeTemplateDocument = new TypedDocumentString(`
    query ZipCodeTemplate {
  v1 {
    info {
      zipCodeTemplate
    }
  }
}
    `) as unknown as TypedDocumentString<ZipCodeTemplateQuery, ZipCodeTemplateQueryVariables>;